const messages = {
  login: {
    form: {
      emailInput: 'Enter your email address',
      passwordInput: 'Enter your password',
      submitButton: 'Send',
      forgotPasswordLabel: 'Forgot your password?',
    },
    tooltips: {
      emailValidation: {
        title: 'Error',
        description: 'Please enter a valid email address.',
      },
      passwordValidation: {
        title: 'Error',
        description: 'Please enter a password.',
      },
      loginValidation: {
        title: 'Invalid Data',
        description: 'Please verify your login information and try again.',
      },
      loginNotAllowed: {
        title: 'Access denied',
        description: 'You do not have access permission.',
      },
      blockByIncorrectLogin: {
        title: 'User blocked',
        description:
          'Your user has been blocked for trying too hard. Please contact the Support team.',
      },
      genericError: {
        title: 'Error',
        description:
          'We could not process your request. Please try again later.',
      },
    },
  },
  forgotPassword: {
    form: {
      description:
        'We will send a code to your email address for password recovery.',
      emailInput: 'Enter registered email',
      submitButton: 'Send code',
    },
    tooltips: {
      emailValidation: {
        title: 'Error',
        description: 'Please enter a valid email address.',
      },
    },
  },
  validateCode: {
    form: {
      description: 'We sent the validation code to your email.',
      codeInput: 'Enter receieved code ',
      submitButton: 'Send code',
    },
    tooltips: {
      codeValidation: {
        title: 'Error',
        description: 'Please enter the code that was sent to your email.',
      },
    },
  },
  changePassword: {
    form: {
      description: 'Change Password.',
      newPasswordInput: 'New Password',
      passwordConfirmationInput: 'Confirm your new password',
      submitButton: 'Change password',
      strongPassMessage:
        'IndeCX está atualizando sua política de segurança de senhas e precisamos que você cadastre uma nova senha segura na plataforma',
    },
    tooltips: {
      emptyFieldValidation: {
        title: 'Error',
        description: 'Please enter and confirm your password.',
      },
      passwordValidation: {
        title: 'Error',
        description: 'Passwords must be the same.',
      },
      strongPasswordValidation: {
        title: 'Erro',
        description: 'Senhas devem seguir nova política de segurança',
      },
    },
    alerts: {
      success: {
        title: 'Your password has been changed!',
        description: 'You can now log in with new password.',
      },
      failure: {
        title: 'Oops!',
        description: 'There was an error in the process. Try again.',
      },
    },
  },
  unsubscribe: {
    thankYou: 'Thank you',
    unsubscribeMsg:
      'Success! Your email has been unsubscribed from our plataform!',
    successTitle: 'Your email has been successfully removed!',
    confirm:
      'By clicking on the button below you will be unsubscribed and you will no longer receive this type of email',
    successSubTitle: 'Please advise the reason for your cancellation.',
    successSentFeedback: 'Thanks for sharing your reason!',
    successResubscribe:
      'Ready! you have already been subscribed to this list again.',
    reasons: {
      dontReceiveEmails: "I don't want to receive these emails anymore",
      notInterested: "The content doesn't interest me",
      dontAllowReceiving:
        "I don't like to receive this type of email without being consulted",
      accidentallyCanceled:
        'I unsubscribed by accident! I want to subscribe to this list again, please',
      other: 'Other',
    },
  },
  researchPage: {
    title: 'Satisfaction Survey',
    firstMsg: 'Your opinion is very important to us!',
    secondMsg: 'Thank you for participating',
    defaultFeedbackMessage: 'Do you want to leave a comment?',
    send: 'Send',
    name: 'Name',
    email: 'Email',
    phone: 'Phone',
    errorMsg: {
      title: 'Oops...Something went wrong!',
      description: 'Please try again later.',
    },
    noQuestion: {
      title: 'Oops... Main question was not answered.',
      description: 'Please put in a score.',
    },
    unavailable: {
      title:
        'Sorry, unfortunately this link is no longer available for searching!',
      description:
        "But don't worry, our team of experts will be sending you a new survey soon to improve your experience with our product and we'd be delighted to hear from you!",
    },
  },
  ssoError: {
    title: 'Your credentials are incorrect!',
    description:
      'Your account may not exist or is blocked. Contact the manager responsible for your IndeCX account.',
  },
  previewPage: {
    title: 'Satisfaction Survey',
    firstMsg: 'Your opinion is very important to us!',
    secondMsg: 'Thank you for participating',
    back: 'Back',
    send: 'Send',
  },
  notFound: {
    title: 'Page not found',
    message:
      "The page you are trying to access is not available or doesn't exist.",
    knowMore: 'Find out more ',
    clickHere: 'click here.',
    back: 'Back',
  },
  ssoPage: {
    auth: 'Authenticating',
    noAuth: "Couldn't authenticate",
  },
  authentication: {
    accessCode: 'Access code',
    validate: 'Validate',
    noAccess: 'No access to this phone',
  },
  menu: {
    allActionsLabel: 'all actions',
    titleMasterSettings: 'Master Settings',
    titleSettings: 'Settings',
    titleMyProfile: 'My Profile',
    titleExportPdf: 'Export to PDF',
    settings: {
      accountData: {
        name: 'Account Info',
        company: 'Company',
        cnpj: 'CNPJ',
        plan: 'Plan',
        email: 'Email',
        apiKey: 'API Key',
        privacyPolicy: 'Privacy Policy',
        clickHere: 'Click here to access.',
        none: 'None',
        mainMetric: 'Primary metric',
        mainTime: 'Primary Period',
        addEmail: 'Add email',
        addPolicyLink: 'Privacy Policy URL',
        registerEmail: 'Register Email',
        chooseLogo: 'Choose Logo',
        companyEmail: 'Company Email',
        choosePrivacyPolicy: 'Choose Privacy Policy',
        cancel: 'Cancel',
        saveLogo: 'Save logo',
        savePrivacyPolicy: 'Save Privacy Policy',
        myCompany: 'My company',
        consumptionDetails: 'Consumption details',
        categories: 'Categories',
        consumptionDetailsShootingAnswer:
          'DETAILS OF DISPATCH/ANSWER CONSUMPTION',
        channelDetailing: 'By Channel Details',
        actionDetailing: 'By Action Details',
        titleListCategories: 'CATEGORY LIST',
        titleListCategoriesGroup: 'CATEGORIES GROUPS LIST',
        titleListTagsGroup: 'TAGS GROUPS LIST',
        placeholderNewGroupTag: 'New tags group',
        listTags: 'TAGS LIST',
        tagsGroup: 'TAGS GROUP',
        customStatus: 'CUSTOM STATUS LIST',
        customRules: 'LIST OF TREATMENT RULES',
        customFilters: 'LIST OF CUSTOM FILTERS',
        placeholderStatus: 'New custom status',
        placeholderRules: 'New operating rule',
        newTag: 'New Tag',
        selectedTag: 'SELECTED TAGS GROUP',
        newCategory: 'New Category',
        newCategoryGroup: 'New category group',
        selectCategoryGroup: 'Select Category Group',
        categoryGroup: 'Category Group',
        branch: 'Branch',
        ih2: 'IH2',
        addSubCategory: 'Add subcategory',
        templates: 'Template',
        custom: 'Template Creation/Customization',
        descriptionCustom:
          'On this screen you can create templates shared with all platform users to be used in your customers dealings.',
        subject: 'Subject',
        sender: 'Sender',
        descriptionTemplate:
          'Configure and save your templates so that you can use them again quickly and conveniently.',
        myTemplates: 'My templates',
        descriptionMyTemplates:
          'Select a template below to view the email formatting and make changes if necessary.',
        saveTemplates: 'Save templates',
        save: 'Save',
        updateTemplate: 'Update template',
        deleteTemplate: 'Delete template',
        labels: {
          collectionChannel: 'Collection Channel',
          shoot: 'Dispatch',
          reminder: 'Reminder',
          resend: 'Resend',
          replica: 'Replica',
          totalShoots: 'Total Dispatches',
          answers: 'Answers',
          action: 'Action',
          sms: 'SMS',
          wpp: 'Whatsapp',
          active: 'Active',
          name: 'Name',
          others: 'Others',
          conversion: 'Conversion Rate',
        },
        messages: {
          registerEmail: {
            title: 'Email has been registered!',
            description:
              'A new sender email address has been registered for the company!',
          },
          cost: {
            title: 'Company email',
            description:
              'By using your email as a sender email, this will generate an additional cost per month, do you really wish to enable this option?',
          },
          updateMetric: {
            title: 'Update primary Metric',
            description:
              'Are you sure you want to update your primary metric to view data?',
          },
          updateMetricSucess: {
            title: 'Metric Updated!',
            description: 'Your primary metric has been successfully updated!',
          },
          updatePeriod: {
            title: 'Change main period',
            description:
              'Are you sure you want to change your Main Period for viewing data?',
          },
          updatePeriodSucess: {
            title: 'Period Changed!',
            description: 'Your main period has been changed successfully!',
          },
          buttons: {
            btnCancel: 'Cancel',
            btnUpdate: 'Change',
          },
          error: {
            title: 'Oops... Something went wrong!',
            description: 'Error',
          },
          updateLogo: {
            title: 'Logo Updated!',
            description: 'The page will be reloaded to view changes...',
          },
          saveBranchRuleSuccess: {
            title: 'Success!',
            description:
              'The branch rule {branchDataName} has been registered.',
          },
          saveBranchRuleError: {
            title: 'Error',
            description: 'Something went wrong!',
          },
          invalidEmail: {
            title: 'Invalid email',
            description: 'Enter a valid e-mail address',
          },
          privacyPolicyUpdate: 'Your Privacy Policy has been updated!',
          enableResurvey: {
            switchLabel: 'Enable resurvey',
            alertSuccess: {
              title: 'Success!',
              description:
                'The resurvey configuration has been changed for your company.',
            },
          },
          duplicatedGroup: {
            title: 'Oops',
            description: 'Category group already exists',
          },
          createdGroup: {
            title: 'Success',
            description: 'Category group successfully created!',
          },
          updatedGroup: {
            title: 'Success',
            description: 'Category group successfully updated!',
          },
          deletedGroup: {
            title: 'Success',
            description: 'Category group successfully deleted!',
          },
          duplicatedCategory: {
            title: 'Oops',
            description: 'Category already exists',
          },
          createdCategory: {
            title: 'Success',
            description: 'Category successfully created!',
          },
          updatedCategory: {
            title: 'Success',
            description: 'Category successfully updated!',
          },
          deletedCategory: {
            title: 'Success',
            description: 'Category successfully deleted!',
          },
          updatedSubCategory: {
            title: 'Success',
            description: 'Subcategory successfully updated!',
          },
        },
        notification: {
          button: 'E-mail notification',
          modalTitle: 'E-mail notification',
          modalDescription:
            'You will be alerted monthly whenever your accounts consumption percentage reaches 90% or more.',
          inputEmail: 'Enter the email that will receive the notification',
          enableNotification: 'Enable',
        },
        category: {
          removeTitle: 'Delete Category',
          removeDescription:
            'All responses linked to that category will be affected. Do you wish to continue?',
          cancelDescription: 'Cancel',
          deleteDescription: 'Delete',
          successTitle: 'Success!',
          successDescription: 'The category has been successfully deleted!',
        },
        subCategory: {
          removeTitle: 'Delete Subcategory',
          removeDescription:
            'All responses linked to this subcategory will be affected. Do you wish to continue?',
          cancelDescription: 'Cancel',
          deleteDescription: 'Delete',
          successTitle: 'Success!',
          successDescription: 'Subcategory was deleted successfully!',
        },
      },
      users: {
        name: 'Users',
        email: 'Email',
        titleNewUser: 'NEW USER',
        titleUpdateUser: 'Edit User',
        titlePermissions: 'Permissions for {userName}',
        titleBranches: 'Branches',
        titleIh2: 'IH2',
        titleViewingProfile: 'Viewing Profile',
        titleActions: 'Actions',
        placeholderNameUser: 'Username',
        placeholderEmailUser: 'User Email',
        placeholderPhoneUser: 'User cell phone',
        placeholderPostUser: 'User position',
        placeholderPassUser: 'New user password',
        placeholderBranch: 'Enter the branch',
        placeholderHierarchy: 'Enter the Hierarchy name',
        placeholderSearch: 'Search...',
        placeholderProfileName: 'Profile Name',
        invalidFeedbackName: 'Please enter the username.',
        invalidFeedbackEmail: 'Please enter a valid email address.',
        invalidFeedbackPhone: 'Please enter user cell phone.',
        invalidFeedbackPost: 'Please enter user position.',
        invalidFeedbackProfile: 'Please enter user profile.',
        invalidFeedbackPass: 'Please enter user password.',
        invalidFeedbackSamePass: 'Passwords must be the same.',
        listActions: 'List of Actions',
        clear: 'Clear',
        buttonRegister: 'Register',
        buttonPermissons: 'Permissions',
        buttonSave: 'Save',
        buttonCancel: 'Cancel',
        chooseOption: 'Choose an option',
        securityPassword:
          'For security reasons, your login password is not displayed on the platform; however, you can edit it at anytime.',
        expiredSecurityPassword:
          'For security reasons, your login password must be changed',
        expiredSendEmail: 'We will send a code to the email:',
        selectAll: 'Select all',
        labels: {
          nameUser: 'Name',
          phone: 'Phone',
          post: 'Position',
          currentPassword: 'Current Password',
          confirmNewPassword: 'Confirm new password',
          updatePassword: 'Change password',
          permission: 'Permission',
          profile: 'Profile',
          viewingProfile: 'Viewing Profile',
          passwordUser: 'New User password',
          repeatPassword: 'Repeat password',
          user: 'User',
          company: 'Company',
          lastLogin: 'Last Access',
          options: 'Options',
          email: 'Email',
          telephone: 'Telephone',
          responsible: 'Responsible for Treatment',
          selectAll: 'Select All',
          branch: 'Branch',
          date: 'Date',
          enable: 'Enable',
          controlId: 'Control Id',
          actions: 'Actions',
          groupAction: 'Action Group',
          creationDate: 'Creation Date',
          channel: 'Channel',
          status: 'Status',
          menu: 'Menu',
          master: 'Master',
          admin: 'Admin',
          analyst: 'Analyst',
          other: 'Other',
          none: 'None',
          accessPassword: 'Access Password',
          changeExpiredPassword: 'Change Access Password',
          twoFactorText:
            'Your account is secured with two factor authentication. Please enter the verification code that was sent to the email:',
          menuModal: 'Menu {position}',
        },
        messages: {
          registerUser: {
            text: 'User Registered',
            description: 'New user has been registered in the system!',
          },
          deleteUser: {
            text: 'Delete User',
            description:
              'Are you sure you want to delete {name} from your list of users?',
          },
          savedChanges: {
            text: 'Changes saved!',
            description:
              'Changes for user {userName} have been successfully saved!',
          },
          failedUpdate: {
            text: 'Oops! Something went wrong...',
            description:
              'Please verify user cell phone and email and try again.',
          },
          updatePermissions: {
            text: 'Error',
            description:
              'There was an error with assigning branches/hierarchies to the user. Please try again.',
          },
          editOk: {
            text: 'Changes Saved!',
            description1: 'Changes for the user',
            description2: 'have been saved successfully!',
          },
          editError: {
            text: 'Oops! Something went wrong...',
            description:
              'Please verify user cell phone and email and try again.',
          },
          editUser: {
            title: 'Edit User',
            description: 'Profile has been updated successfully!',
          },
          incorrectData: {
            title: 'Incorrect data',
            description: 'Please fill in the fields correctly.',
          },
          updatePassword: 'Password has been updated successfully!',
          performedAssignments: 'Assignments have been completed!',
          newBranchesAssigned:
            'New branches/hierarchies have been assigned to the user.',
          error: 'Error',
          eightCharacters: 'Must contain at least eight characters',
          containNumbers: 'Must contain numbers',
          containCapitalLetters: 'Must contain capital letters',
          containSpecialCharacters: 'Must contain special characters',
        },
      },
      alertsNewsletters: {
        name: 'Alerts/Newsletters',
        yes: 'Yes',
        no: 'No',
        editRule: 'Edit Rule',
        cancel: 'Cancel',
        save: 'Save',
        alerts: 'Alerts',
        bulletin: 'Newsletter',
        ruleBranch: 'Branch rule {branchDataName}',
        close: 'Close',
        titleNewRule: 'NEW RULE',
        titleGeneral: 'General',
        titleBranch: 'Branch',
        diary: 'DAILY',
        monthly: 'MONTHLY',
        weekly: 'WEEKLY',
        yearly: 'YEARLY',
        none: 'None',
        buttonRegister: 'Register',
        buttonClear: 'Clear',
        placeholderRuleName: 'Type in Rule Name',
        placeholderEmail: 'Type in email',
        placeholderStaggering: 'Type in dispatching email',
        placeholderSearch: 'Search...',
        feedbackRuleName: 'Please enter rule name.',
        feedbackEmail: 'Please enter email.',
        feedbackEmailUser: 'Please enter user email.',
        emailAlert: 'Emails that will receive alerts (by score)',
        emailsAlertNote: 'Emails that will receive alerts (by score)',
        alertNote: 'Will receive alerts (by score)',
        staggering: 'Dispatching',
        savedRules: 'Rules Saved',
        actions: 'Actions',
        yesLabel: 'Yes',
        noLabel: 'No',
        table: {
          branch: 'Branch',
          hasAlert: 'Is there an alert?',
          updated: 'Updated rule date',
          options: 'Options',
        },
        labels: {
          ruleName: 'Rule name',
          email: 'Email',
          onlyReplyComment: 'Only responses with comments',
          levelOneEmail: 'Level One Email',
          levelTwoEmail: 'Level Two Email',
          levelThreeEmail: 'Level Three Email',
          days: 'Days',
          branch: 'Branch',
          haveAlert: 'Is there an alert?',
          ruleUpdateDate: 'Updated rule date',
          options: 'Options',
          selectAllNotes: 'Select all notes',
        },
        messages: {
          insertNameRule: {
            title: 'Oops!',
            description: 'Please enter a name for the rule!',
          },
          ruleForBranch: {
            title: 'Oops!',
            description:
              'To view the rules by branches, a primary rule must be created, do you want to do this?',
          },
          successRegisterRule: {
            title: 'Rule Registered',
            description: 'A new rule has been registered successfully!',
          },
          handleDelete: {
            title: 'Are you sure?',
            description:
              'Do you wish to delete the alert rule for branch {branchName}?',
          },
          deleteRuleBrachSuccess: {
            title: 'Success!',
            description: 'The rule for branch {branchName} has been deleted.',
          },
          updateRule: {
            title: 'Success!',
            description: 'The rule has been successfully edited!',
          },
          deleteRuleQuestion: {
            title: 'Delete Rule',
            description:
              'Are you sure you want to delete this rule from your list?',
            cancel: 'Cancel',
            delete: 'Delete',
            deletedOk: 'Rule deleted successfully!',
          },
          deleteBranchRule: {
            title: 'Are you sure?',
            description:
              'Are you sure you want to delete the alert rule for the branch?',
            deletedOkTitle: 'Success!',
            deletedOkMsg1: 'The rule for the branch',
            deletedOkMsg2: ' has been deleted.',
          },
          enterNameRule: {
            title: 'Oops!',
            description: 'Please enter a name for the rule.',
          },
          ruleRegistered: 'Rule {newRuleName} has been registered.',
          pleaseInsertNameRule: 'Please enter a name for the rule.',
        },
      },
      hierarchies: {
        name: 'Hierarchies',
        titleNewBranch: 'NEW BRANCH',
        titleUpdateBranch: 'Edit Branch',
        titleNewHierarchies: 'NEW HIERARCHY',

        clear: 'Clear',

        placeholderNameBranch: 'Enter the branch name',
        placeholderEnterDescription: 'Enter the description',
        placeholderEnterGroup: 'Enter the group',
        placeholderEnterCode: 'Enter the code',
        placeholderCustomField: 'Custom Field',
        placeholderValue: 'Value',
        placeholderSearch: 'Search...',
        placeholderIh2: 'Ex.: Sales, After-Sales, etc.',

        buttonRegister: 'Register',
        buttonCancel: 'Cancel',
        buttonRemove: 'Remove',
        buttonSave: 'Save',

        feedbackInformBranch: 'Please enter the branch.',
        feedbackInformDescription: 'Please enter the description.',
        feedbackInformGroup: 'Please enter the group.',
        feedbackInformCode: 'Please enter the code.',
        feedbackInformHierarchiesName: 'Please enter the hierarchy name.',
        branchRemoved: 'Branch Removed!',
        hierarchyRemoved: 'Hierarchy Removed!',

        labels: {
          nameBranch: '*Branch',
          branch: 'Branch',
          creationDate: 'Creation Date',
          options: 'Options',
          description: 'Description',
          group: 'Group',
          code: 'Code',
          customField: 'Custom Field',
          value: 'Value',
          hierarchiesName: '*Hierarchy Name',
          corporationName: 'Name',
        },
        messages: {
          succesAddBranch: {
            title: 'Branch Added',
            description: 'A new branch has been created!',
          },
          removeBranch: {
            title: 'Remove Branch?',
            description: 'Do you wish to remove the selected branch?',
          },
          changesSaved: {
            title: 'Changes Saved!',
            description: 'Changes have been saved successfully!',
          },
          succesAddHierarchy: {
            title: 'Hierarchy Registered',
            description: 'A new hierarchy has been registered!',
          },
          removeHierarchy: {
            title: 'Remove Hierarchy?',
            description: 'Do you wish to remove the selected hierarchy?',
          },
        },
      },
      accessProfile: {
        name: 'Access Profile',
        profileList: 'PROFILE LIST',
        buttonNewProfile: 'New Profile',
        myProfile: 'My profile',
        newPassword: 'Type in a new password',
        email: 'Email',
        profile: 'Profile',
        telephone: 'Telephone',
        updatePassword: 'Change Password',
        registerNewProfile: 'Register New Profile',
        nameProfile: 'Name',
        buttonCancel: 'Cancel',
        confirmNewPassword: 'Confirm new password',
        nameUser: 'Name',
        registeredIn: 'Registered in',
        lastLogin: 'Last Access',
        post: 'Position',
        buttonRemove: 'Remove',
        removed: 'Removed',
        removeProfile: 'Remove profile',
        options: 'Options',
        editProfile: 'Edit profile',
        personalInformation: 'Personal Information',
        status: 'Status',
        informName: 'Please state the name',
        informEmail: ' Please state the email.',
        informTelephone: 'Please enter the telephone.',
        informPost: 'Please enter the position.',
        accessPassword: 'Access Password',
        securityPassword:
          'For security reasons, your login password is not displayed on the platform; however, you can edit it at anytime',
        currentPassword: 'Current Password',
        messages: {
          editUser: {
            title: 'User edited',
            description: 'Profile has been edited successfully!',
          },
          updatePassword: 'Password updated successfully!',
        },
      },
      integrations: {
        name: 'Integrations',
        titleZenvia: 'Zenvia',
        titleEnterPhone: 'Enter cell phone number to test',
        titleStatus: 'Integration status',
        titleCollectResponse: 'Webhook - Coleta de resposta',
        titleCollectShoot: 'Webhook - Collect shoot',
        titleApiKey: 'Chave de integração Via API',
        integrationHabilit: 'Enable Integration',
        integrationTest: 'Test Integration',
        required: 'Requerido: http:// ou https://',
        postUrl: 'HTTP Post URL',
        descriptionCollect:
          'Esse evento permite a configuração de um end-point para recebimento dos dados coletados em tempo real de cada cliente.',
        descriptionModelReturn: 'Veja o modelo de retorno das informações.',
        descriptionApi:
          'Você pode utilizar a chave "company-key" para utilizar as APIs de integrações do Indecx. Consulte a documentação para mais detalhes.',
        companyKey: 'Company Key',
        status: 'Status',
        integration: 'Integration',
        description: 'Description',
        enabled: 'Enabled',
        descriptionZeenvia:
          'Utilize os créditos de SMS da sua conta Zeenvia integrando com o Indecx de forma fácil e rápida.',
        descriptionApiKey:
          'Habilite a opção para gerar a chave de autenticação e habilitar a opção de integração de API.',
        event: 'Event',
        collectionAnswers: 'Coleta de resposta',
        collectDescription:
          'Cadastre um end-point para recebimento em tempo das respostas coletadas pelo Indecx.',
        loopDescription:
          'Cadastre um end-point para recebimento em tempo das tratativas realizadas sempre que um status de um cliente for concluído.',
        phone: 'Telephone',
        cancel: 'Cancel',
        save: 'Save',
        userNameZenvia: 'Zenvia Username',
        aggregateId: 'Aggregate Id',
        placeholderEnterUserName: 'Type in Zenvia username',
        placeholderEnterPass: 'Enter Zenvia password',
        placeholderEnterAggregateId: 'Enter the Aggregate Id',
        placeholderEnterUserTest: 'Enter Zenvia username for testing',
        placeholderEnterPasswordTest: 'Enter Zenvia password for testing',
        placeholderAggregateIdTest: 'Type in aggregate id for testing',
        placeholderEnterPhone: 'Enter cell phone number to receive a SMS',
        feedbackInformUserName: 'Please state username.',
        feedbackInformPass: 'Please enter password.',
        feedbackInformAggregateId: 'Please enter the Aggregate Id.',
        passwordLabel: 'Zenvia Password',
        disabled: 'Disabled',
        lineOneDescription:
          'You can use credit from your Zenvia account by quickly enabling integration.',
        lineTwoDescription:
          "Fill in the fields below with your Zenvia account data, enable the option and you're all set.",
        lineThreeDescription:
          'All SMS messages that are sent through the platform will use the balance from your Zenvia account.',
        messages: {
          settingsSaved: {
            title: 'Settings Saved!',
            description:
              'The integration settings with Zenvia have been saved successfully!',
          },
          successSendSMS: {
            title: 'SMS sent successfully!',
            description: 'Success',
          },
          errorSettings: {
            title: 'Error',
            description: 'Wrong Settings!',
          },
        },
      },
    },
    masterSettings: {
      titleNewCompany: 'NEW COMPANY',
      titleEditCompany: 'Edit Company',
      titleNewUser: 'NEW USER',
      titleAllCompanies: 'All Companies',
      titleAllUsers: 'All Users',
      titleReports: 'Reports',
      titleNewReport: 'NEW REPORT',
      logo: 'Logo',
      master: 'Master',
      admin: 'Admin',
      analyst: 'Analyst',
      adminAccess: 'Admin access',
      ops: 'Oops!',
      general: 'General',
      segments: {
        foodDrinks: 'Food and Drinks',
        artAntiques: 'Art and Antiques',
        religiousArticles: 'Religious Articles',
        subscriptionsMagazines: 'Subscriptions and Magazines',
        automobilesVehicles: 'Automobiles and Vehicles',
        babiesCompany: 'Babies and Company',
        giftsPromotionalMaterials: 'Gifts/Promotional Materials',
        toysGames: 'Toys and Games',
        houseDecoration: 'Home and Decoration',
        collectibles: 'Collectibles',
        coletiveShopping: 'Collective Shopping',
        constructionTools: 'Construction and Tools',
        cosmeticsPerfumery: 'Cosmetics and Perfumery',
        coursesEducation: 'Courses and Education',
        vinylsDiscs: 'Vinyl Records',
        homeAppliances: 'Home Appliances',
        electronics: 'Electonics',
        radioBroadcasters: 'Radio Broadcasting',
        televisionBroadcasters: 'Television Broadcasting',
        jobs: 'Jobs',
        telemarketingCompanies: 'Telemarketing Companies',
        sportsLeisure: 'Sport and Recreation',
        flowersBasketsGifts: 'Flowers, Baskets and Gifts',
        photography: 'Photography',
        churchesTemplesReligiousInstitutions:
          'Churches / Temples / Religious Institutions',
        industryCommerceBusiness: 'Industry, Commerce and Business',
        promotionalInflatables: 'Promotional Inflatables',
        computing: 'Computing',
        tickets: 'Tickets',
        musicalInstruments: 'Musical Instruments',
        jewelry: 'Jewelry',
        recreation: 'Recreation',
        books: 'Books',
        fashionAccessories: 'Fashion Accessories',
        digitalMusic: 'Digital Music',
        businessOpportunities: 'Business and Opportunities',
        otherServices: 'Other Services',
        stationeryOffice: 'Stationery Office',
        easter: 'Easter',
        petShop: 'Pet Shop',
        cheers: 'Health',
        advocacyService: 'Advocacy Service',
        newspaperMagazineDistributionService:
          'Newspaper/Magazine Distribution Service',
        administrativeServices: 'Administrative Services',
        artisticServices: 'Artistic services',
        airportServices: 'Airport Services',
        agencyServices: 'Agency Services',
        rentalLeasingServices: 'Rental/Leasing Services',
        warehousingServices: 'Warehouse Services',
        advisoryServices: 'Advisory Services',
        technicalAssistanceServicesFacilities:
          'Technical and Assistance Service Facilities',
        associationServices: 'Association Services',
        bloodBankServices: 'Blood Bank Services',
        libraryServices: 'Library Services',
        notaryServices: 'Notary Services',
        lotteryServices: 'Lottery Services',
        clothingServices: 'Fabric Services',
        consortiumServices: 'Consortium Services',
        consultingServices: 'Consulting Services',
        cooperativeServices: 'Cooperative Services',
        dispatcherServices: 'Dispatcher Services',
        engineeringServices: 'Engineering Services',
        parkingServices: 'Parking Services',
        shipyardServices: 'Shipyard Services',
        exportImportServices: 'Exportation/Importation Services',
        geologistServices: 'Geologist Services',
        jewelerServices: 'Jeweler Services',
        auctioneerServices: 'Auctioneer Services',
        cleaningServices: 'Cleaning Services',
        convenienceStoreServices: 'Convenience Store Services',
        laborServices: 'Labor services',
        publicOrganServices: 'Public Organ services',
        researchServices: 'Research Services',
        portServices: 'Port Services',
        healthWellnessServices: 'Wellness Center/Health Services',
        insuranceServices: 'Insurance Services',
        securityServices: 'Security Services',
        signalingServices: 'Signaling Services',
        unionFederationServices: 'Union/Federation Services',
        translationServices: 'Translation Services',
        transportServices: 'Transportation Services',
        publicUtilityServices: 'Public Utility Services',
        servicesAgricultureLivestockFishFarming:
          'Agricultural/Livestock/FishFarming Services',
        foodServices: 'Food Services',
        servicesArt: 'Art Services',
        communicationServices: 'Communication Services',
        constructionServices: 'Construction Services',
        ecologyEnvironmentServices: 'Ecological and Environmental Services',
        servicesElectronicsMetalMechanics:
          'Electronics and Metal Mechanic Services',
        partyEventServices: 'Party and Event Services',
        computerServices: 'Computer Services',
        internetServices: 'Internet Services',
        jeweleryWatchesOpticalServices: 'Jewelery/Watches/Optical Services',
        technologyServices: 'Technology Services',
        telephonyServices: 'Telephony Services',
        vehicleServices: 'Vehicle Services',
        esotericMysticalServices: 'Esoteric/Mystical Services',
        financialServices: 'Financial Services',
        funeralServices: 'Funeral Services',
        generalServices: 'General Services',
        graphicEditorialServices: 'Graphic Design/Editorial Services',
        animalServices: 'Animal Services',
        servicesDisabled: 'Handicap Services',
        officeServices: 'Office Services',
        clothingForServices: 'Clothing Services',
        socialAAssistanceServices: 'Social Assistance Services',
        shoppingCenters: 'Shopping Centers',
        tobacconist: 'Tobacconist',
        bankFee: 'Bank Fees',
        telephoneCharges: 'Telephone Charges',
        telephony: 'Telephony',
        tourism: 'Tourism',
      },
      specific: 'Specific',
      clear: 'clear',
      noUserRegistered: 'No user registered for this company.',
      removedReport: 'Report removed',
      removedCompany: 'Company removed',
      buttonRegister: 'Register',
      buttonSave: 'Save',
      buttonCancel: 'Cancel',
      placeholderCorporationName: 'Corporation Name',
      placeholderCompanyName: 'Company Name',
      placeholderUserName: 'Username',
      placeholderPhone: 'User cell phone',
      placeholderCnpj: 'Company CNPJ',
      placeholderCountry: 'Company country',
      placeholderReference: 'Reference date indicator',
      placeholderPassword: 'New User Password',
      placeholderSequence: 'Type in the segment...',
      placeholderLogo: 'Choose a logo for the company',
      placeholderDropFile: 'Drop file here...',
      placeholderEmail: 'User email',
      placeholderSearch: 'Search...',
      placeholderPostUser: 'User position',
      placeholderReportsName: 'Report name',
      feedbackInformCorporationName: 'Please state the corporation name.',
      feedbackInformCompanyName: 'Please state the company name.',
      feedbackInformCnpj: 'Please state the company CNPJ .',
      feedbackInformSequence: "Please enter the company's segment.",
      feedbackInformPass: 'Please enter user password.',
      feedbackInformReport: 'Please enter the report name.',
      feedbackInformBalance: 'Balance must be entered for the custom plan.',
      feedbackInformNameUser: 'Please state the username.',
      feedbackInformEmail: 'Please state the user email.',
      feedbackInformPhone: 'Please enter user cell phone.',
      feedbackInformPost: 'Please enter user position.',
      feedbackSamePass: 'Passwords must be the same.',
      channelOptions: {
        demo: 'Demo',
        basic: 'Basic',
        intermediate: 'Intermediate',
        advanced: 'Advanced',
        custom: 'Custom',
        dev: 'Dev',
      },
      labels: {
        companyName: 'Company Name',
        fantasyName: 'Trade Name',
        cnpj: 'CNPJ',
        country: 'Country',
        referenceDate: 'Reference date Indicator',
        sequence: 'Segment',
        plan: 'Plan',
        companyLogo: 'Company Logo',
        smsMonth: 'SMS/Month',
        emailMonth: 'Email/Month',
        email: 'Email',
        name: 'Name',
        limit: 'Limit',
        quantityEmail: 'Qtd Email',
        quantitySms: 'Qtd SMS',
        options: 'Options',
        company: 'Company',
        phone: 'Telephone',
        post: 'Position',
        profile: 'Profile',
        passwordUser: 'New user password',
        repeatPassword: 'Repeat password',
        user: 'User',
        lastAcess: 'Last Access',
        application: 'Application',
        client: 'Client',
        activate: 'Activate',
        report: 'Report',
        actions: 'Actions',
        sentiment: 'Enable sentiment analyze',
        enableAttach: 'Allow upload (attachment) treatments',
        enableAudioResponse: 'Allow recording audio in responses',
        channelTotem: 'Enable totem',
        channelCallCenter: 'Enable Click-to-call (Call center)',
        privacyPolicy: 'Enable Privacy Policy by link',
      },
      messages: {
        removeCompany: {
          title: 'Remove Company',
          description: 'Are you sure you want to remove this company?',
        },
        addCompany: {
          title: 'Company registered',
          description: 'New company has been registered in the system!',
        },
        error: {
          title: 'Error',
          description:
            'There was a problem with registering the customer. Please verify the fields and your internet and try again later.',
        },
        successAddUser: {
          title: 'User Registered',
          description: 'New user has been registered in the system!',
        },
        selectCompany: {
          title: 'Oops...',
          description: 'Select a company for the user.',
        },
        userMaster: {
          title: 'Oops...',
          description:
            'Master-type users must mandatorily be from the IndeCX company.',
        },
        removeUser: {
          title: 'Remove User',
          description:
            'Are you sure you want to remove {nameUser} from the list of users?',
        },
        changeOrderList: {
          title: 'Success!',
          description: 'Report order updated!',
        },
        addReport: {
          title: 'Success!',
          description: 'Report registered.',
        },
        removeReport: {
          title: 'Remove report',
          description: 'Are you sure you want to remove this report?',
        },
      },
    },
    filter: {
      filters: 'Filters',
      filterAactionGroup: 'Filter by action group',
      filterAction: 'Filter by action',
      provincialMetric: 'Primary Metric',
      NPS1a5: 'NPS of 1 to 5',
      NPS010: 'NPS of 0 to 10',
      CES1a10: 'CES of 1 to 5',
      CES1a5: 'CES of 1 to 5',
      CSAT1to5: 'CSAT of 1 to 5',
      CSAT1to5Average: 'CSAT of 1 to 5 (Average)',
      CSAT0to10Average: 'CSAT of 0 to 10 (Average)',
      review5Stars: 'REVIEW - 5 Stars',
      likeDislike: 'Like/Dislike - 0 and 1',
      metricsUnavailable: 'Metrics unavailable',
      titleResetFilter: 'Reset Indicator filter',
      titleResetFilterData: 'Reset Data Indicator filter',
      conclude: 'Apply and close',
      clearFilter: 'Clear Filters',
      loading: 'Loading...',
      indicators: 'Indicator data - {indicatorData}',
      indicatorData: 'Indicator Data',
      filterIh1: 'Filter by - {ih1} ',
      filterIh2: 'Filter by - {ih2} ',
      boxIndicator: 'Indicator - {indicatorName}',
      indicator: 'Indicator',
    },
    sidebar: {
      dashboard: 'Dashboard',
      actions: 'Actions',
      actionList: 'Action List',
      newAction: 'New Action',
      actionGroup: 'Action Group',
      answers: 'Answers',
      answersList: 'Answers List',
      sentiment: 'Sentiment Analyze',
      manualAnswer: 'Manual Answer',
      categorization: 'Categorization',
      categorizationGol: 'Categorization Input',
      invites: 'Dispatch',
      resend: 'Resend',
      reminders: 'Reminders',
      scheduling: 'Scheduling',
      treatments: 'Treatments',
      individual: 'Separated',
      bulk: 'Bulk',
      reports: 'Reports',
      reportsList: 'List of Reports',
      clients: 'Customers',
      clientsList: 'Customers List',
      files: 'Files',
      downloads: 'Downloads',
      uploads: 'Uploads',
      reccycleBin: 'Recycle Bin',
      version: 'Version',
      quarentine: 'Quarentine',
      resendwpp: 'Whatsapp',
      treatmentsReview: 'Review',
      aiAnalysis: 'AI Analysis',
    },
    navbar: {
      nps15: 'NPS 1 to 5',
      nps010: 'NPS 0 to 10',
      ces15: 'CES 0 to 10',
    },
    profile: 'Profile',
    leave: 'Leave',
  },
  dashboard: {
    action: 'Action',
    period: 'Period',
    brasil: 'Brazil',
    portugues: 'Português',
    ingles: 'English',
    colombia: 'Colombia',
    espanhol: 'Español',
    eua: 'United States',
    all: 'All',
    invites: 'Invitations',
    customers: 'Customers',
    answers: 'Answers',
    responsesRate: 'Response Rate',
    totalResponseRate: 'Total Response Rate ',
    digitalResponseDate: 'Digital Responses Rate',
    groupActions: 'Action group',
    metric: 'Metric',
    stockComparison: 'Action Comparison',
    updateList: 'Update list',
    todayFilter: 'Today',
    yesterdayFilter: 'Yesterday',
    last30DaysFilter: 'Last 30 days',
    currentMonthFilter: 'Current month',
    lastMonthFilter: 'Last month',
    currentYearFilter: 'Current year',
    lastYearFilter: 'Last year',
    everyPeriodFilter: 'Every period',
    custom: 'Custom',
    CCSI: 'CCSI',
    HGSI: 'HGSI',
    PREHGSI: 'PRE-HGSI',
    FCSI: 'FCSI',
    labelsStockComparison: {
      actionName: 'Action Name',
      answers: 'Answers',
      promoters: '% Promoters',
      neutral: '% Neutrals',
      detractors: '% Detractors',
      nps: 'NPS',
      conversionRate: 'Conversion rate',
      invites: 'Invitations',
    },
  },
  actionList: {
    pageTitle: 'Action List',
    newActionButton: 'New action',
    searchInput: 'Search...',
    searchButton: 'Clear',
    registerGroupAction: 'Register a group',
    veryUnsatisfied: 'Very Unsatisfied',
    here: 'Here.',
    loading: 'Loading...',
    updateList: 'Update List',
    nps010: 'NPS 0 to 10',
    nps15: 'NPS 1 to 5',
    csat15: 'CSAT 1 to 5',
    csat15Average: 'CSAT 1 to 5 (Average)',
    csat0to10Average: 'CSAT 0 to 10 (Average)',
    likeDislike: 'Like/Dislike - 0 and 1',
    fiveStars: 'Reviews - 5 Stars',
    both: 'both',
    details: 'Details',
    edit: 'Edit',
    send: 'Send',
    clone: 'Clone Action',
    remove: 'Remove',
    executed: 'Executed on',
    scheduled: 'Scheduled for',
    registerEmail: 'Register Email (sender)',
    registerWebhook: 'Register webhook',
    required: 'Required: http:// ou https://',
    testIntegration: 'Test integration',
    saveWebhook: 'Save',
    habilitIntegration: 'Enable integration',
    messages: {
      remove: {
        title: 'Remove an Action',
        description: `Are you sure you want to remove this action?
                     This may directly affect your NPS calculation.`,
        okLabel: 'Remove',
        cancelLabel: 'Cancel',
      },
      removeOk: {
        title: 'Action removed!',
        description:
          'Your NPS is being recalculated, this may take a few minutes.',
      },
      clone: {
        title: 'Cloning an Action',
        description:
          'You are about to duplicate the settings of this action, do you wish to continue?',
        okLabel: 'Duplicate',
        cancelLabel: 'Cancel',
      },
      cloneOk: {
        title: 'Action duplicated!',
        description: 'All settings of this action have been duplicated.',
      },
    },
    actionTable: {
      labels: {
        id: 'ID',
        action: 'Action',
        group: 'Action group',
        categoryGroup: 'Cagetory group',
        type: 'Type',
        date: 'Creation Date',
        channel: 'Channel',
        registers: 'Registers',
        valids: 'Valids',
        failures: 'Failures',
        answers: 'Answers',
        status: 'Status',
        options: 'Options',
      },
      noClassifiedLabel: 'No Classification',
      status: {
        criado: 'created',
        processando: 'processing',
        enviando: 'sending',
        enviado: 'sent',
        agendado: 'scheduled',
        falha: 'failure',
        quarentine: 'Quarentine',
        bloqueado: 'blocked',
        importando: 'importing',
        importado: 'imported',
      },
    },
    actionDetails: {
      details: 'Action details',
      cleanInput: 'Clear',
      placeholderSearch: 'Search...',
      actionFilterStatus: {
        select: 'Filter by status',
        all: 'All',
        processando: 'Processing',
        enviando: 'Sending',
        enviado: 'Sent',
        respondido: 'Answered',
        quarentena: 'Quarentine',
        duplicado: 'Duplicating',
        bloqueado: 'Blocked',
        falha: 'Failure',
        importando: 'Importing',
        importado: 'Imported',
      },
      labels: {
        id: 'ID',
        name: 'Name',
        email: 'Email',
        phone: 'Telephone',
        date: 'Sent Date',
        days: 'Days',
        channel: 'Channel',
        emailStatus: 'Email Status',
        phoneStatus: 'Telephone Status ',
        status: 'Status',
      },
      titleExportCSV: 'Export to CSV',
      titleExportXLS: 'Export to XLS',
      alertsActionDetails: {
        succes: {
          title: 'Success!',
          description:
            'File is being prepared! You can track the process status in the "Downloads" menu.',
        },
      },
      notAnswered: 'Not answered',
      answered: 'Answered',
      valid: 'valid',
      invalid: 'invalid',
    },
    resurveyModal: {
      title: 'Configure resurvey rule',
      cancelButton: 'Cancelar',
      saveButton: 'Salvar notas',
      description:
        'Select in the table below what actions with the type "survey" you want to enable the resurvey process...',
      gradesDescription:
        'What grades would you like to send the resurvey to your customer?',
      tableLabels: {
        name: 'Action',
        actionGroup: 'Action Group',
        createdAt: 'Created At',
        channel: 'Channel',
        resurvey: 'Enable resurvey',
      },
    },
  },
  newAction: {
    modalTitle: 'New action',
    createAction: 'Create action',
    stepsLabels: {
      selectMetric: 'Primary Metric',
      stepOne: 'Create Action',
      stepTwo: 'Settings',
      stepThree: 'Import data',
    },
    templateHTML: `<p>Thank you for choosing our company. <br> </p>
                  <p>We would like to improve your experience with our services by organizing this
                   survey that has a duration of only 60 seconds.
                  <br>
                  </p>
                  <p>We thank you for your participation.<br></p>`,
    closeHTML: '<p>Thank you for answering our survey!</p>',
    dynamicClosingMessage: 'Dynamic closure',
    dynamicClosingMessageText: {
      part1:
        'You can customize the closing message according to the grade assigned by the customer.',
      part2: 'Select the scale of grades below and customize the page layout',
    },
    closingMessageGrades: {
      zeroToTen: {
        promoters: 'Grades 10 and 9',
        passives: 'Grades 8 and 7',
        detractors: 'Grades 6 to 0',
      },
      oneToFive: {
        promoters: 'Grades 5 and 4',
        passives: 'Grade 3',
        detractors: 'Grades 2 and 1',
      },
      zeroAndOne: {
        promoters: 'Grade 1',
        passives: '',
        detractors: 'Grade 0',
      },
    },
    autoReplyGrades: {
      zeroToTen: {
        promoters: 'Grades 10 and 9',
        passives: 'Grades 8 and 7',
        detractors: 'Grades 6 to 0',
      },
      oneToFive: {
        promoters: 'Grades 5 and 4',
        passives: 'Grade 3',
        detractors: 'Grades 2 and 1',
      },
      zeroAndOne: {
        promoters: 'Grade 1',
        passives: '',
        detractors: 'Grade 0',
      },
    },
    buttonReturn: 'Back',
    buttonSave: 'Save Action',
    buttonSaveConfig: 'Save Setting',
    buttonSaveAndExit: 'Save and close',
    nameAction: 'ACTION NAME',
    answerSurvey: 'Answer our survey here:',
    anonymousAnswer: 'Quero responder de forma anônima',
    selectMetric: {
      pageTitle: 'Choose your primary metric',
      button: {
        selectLabel: 'Select',
        soonLabel: 'Soon',
      },
      nps: {
        title: 'Want to know what NPS is?',
        description:
          'NPS, which means Net Promoter System or Net Promoter Score is a customer loyalty and satisfaction indicator that is very much used worldwide. It measures, through only one question, the level of loyalty and satisfaction customers have with the company, service or product.',
      },
      ces: {
        title: 'Want to know what a CES is?',
        description:
          'The Customer Effort Score (CES) or Customer Effort Index (IEC) is a key performance indicator (KPI) to measure how much effort a customer needs to expend to get an answer or solution to a problem. Basically, it is used to create an effortless experience for customers.',
      },
      csat: {
        title: 'What to know what CSAT is?',
        description:
          'The Customer Satisfaction Score (CSAT) is a metric that demonstrates the level of satisfaction a customer has with a company, product, or service. CSAT is a very popular methodology mainly because of its simple way of measuring the collected responses.',
      },
      likert: {
        title: 'Want to know what a Likert is?',
        description: `Likert scale, is a metric made to measure people's attitudes, opinions, or perceptions. Customers choose between a variety of possible answers that best reflect their opinions such as "Very Satisfied", "Satisfied", "Indifferent", "Unsatisfied", and "Very unsatisfied".`,
      },
      reviews: {
        title: 'Want to know what are Reviews?',
        description:
          '5-Star Rating is probably the most common and present metric in our day-to-day lives and used by many companies in app segments such as transportation, delivery, banks, etc... It allows a more visual form of review (stars) and the result is calculated by its weighted arithemetic mean.',
      },
      likeDislike: {
        title: 'Want to know what are like/dislike?',
        description:
          'Known as Thumbs Up/Down or popular Like/Dislike is a great option to analyze feedback in the most direct as possible, since it is a very common metric used in several applications I use on a daily basis for evaluation.',
      },
    },
    stepOne: {
      labels: {
        actionName: 'Action name',
        scale: 'Scale',
        methodology: 'Methodology',
        collectionCanal: 'Collection Channel',
        actionType: 'Action Type',
        surveyType: 'Survey',
        resurveyType: 'Resurvey',
        question: 'Question',
        infoQuestion:
          'To change the main question, click on the edit option of the main template (lapis icon)',
        replicas: 'Replicas',
        commentOrder: 'Comment Order',
        afterAdditionalQuestion: 'After additional question',
        beforeAdditionalQuestion: 'Before additional question',
        additionalQuestion: 'Additional Question',
        addQuestion: 'Additional question?',
        smsQuestion: 'SMS question',
        csatScale: 'CSAT - 1 to 5 scale',
        csatScaleAverage: 'CSAT - 1 to 5 scale(average)',
        csatScaleAverage0to10: 'CSAT - 0 to 10 scale(average)',
        fiveStars: 'Review - 5 Stars',
        likeDislike: 'Like/Dislike - 0 and 1',
        able: 'Enabled',
        chooseOption: 'Choose an option',
        settingSMS: 'SMS settings',
        openFieldPromoters9a10: 'Open field for promoters (scores 9 and 10)',
        openFieldPassives7e8: 'Open field for neutrals (scores 7 and 8)',
        openFieldDetractors0a6: 'Open field for detractors (scores 0 to 6)',
        openFieldPromoters4e5: 'Open field for promoters (scores 4 and 5)',
        openFieldPassives3: 'Open field for neutrals (score 3)',
        openFieldDetractors1e2: 'Open field for detractors (scores 1 to 2)',
        openFieldCESPromoters4e5: 'Open field for scores 4 and 5',
        openFieldCESPassives3: 'Open field for score 3',
        openFieldCESDetractors1e2: 'Open field for scores 1 and 2',
        openFieldCSAT4and5: 'Open field for notes 4 and 5',
        openFieldCSAT3: 'Field open for note 3',
        openFieldCSAT1and2: 'Field open for notes 1 and 2',
        openField5Stars4and5: 'Open field for promoters (scores 4 and 5)',
        openField5Stars3: 'Open field for neutrals (score 3)',
        openField5Stars1and2: 'Open field for detractors (scores 1 to 2)',
        openFieldLikeDislike1: 'Open field for promoters (score 1)',
        openFieldLikeDislike0: 'Open field for detractors (score 0)',
        sms: 'Type the message for the survey link',
        english: 'Inglês',
        spanish: 'Espanhol',
        portuguese: 'Português',
        modalTranslationAddQuestion:
          'Ao configurar a tradução das perguntas adicionais, os respondentes poderão escolher o idioma preferido para responder a pesquisa.',
        modalTranslationReplies:
          'Ao configurar a tradução das réplicas, os respondentes poderão escolher o idioma preferido para responder a pesquisa.',
      },
      saveChanges: 'Save changes',
      radioOptions: {
        email: 'Email',
        sms: 'SMS',
        emailSMS: 'Email/SMS',
      },
      infoComment:
        'By enabling this option, a comment field will be available for the customer to add a specific note about this additional question.',
      searchLink: 'Search with SMS link',
      searchBody: 'Survey in  message body of SMS',
      veryUnsatisfied: 'Very Unsatisfied',
      points0a10: '0 to 10 points',
      yes: 'YES',
      email: 'Email',
      sms: 'SMS',
      emailSMS: 'Email/SMS',
      doNotExclude: 'DO NOT EXCLUDE',
      detractorsSMS: 'Detractors',
      promotersSMS: 'Promoters',
      placeholderDetractor: 'Type in a replica for the detractors',
      placeholderNeutral: 'Type in a replica for the neutrals',
      placeholderPromoter: 'Type in a replica for the promoters',
      placeholderEnterSubjectSMS: 'Type in a SMS subject',
      placeholderTextLink: 'Text for link',
      placeholderTextBody: 'Text in the message body',
      altCellPhone: 'cell phone',
      selectTitle: 'Select {selectTemplate}',
      neutralSMS: 'Neutrals',
      actionName: 'State Action Name',
      actionCSATName: 'New CSAT action name',
      action5StarsName: 'New 5-Stars action name',
      actionNameSize: 'Cannot exceed 35 characters.',
      actionInvalid: 'Please state the action name.',
      actionSavedAlert: 'Action Saved!',
      skipSettings: 'Advance to Settings',
      promoters: 'What made you give this rating?',
      neutral:
        'In your opinion, what are we lacking in order to get a top score?',
      detractors: 'In your opinion, which items should be improved?',
      surveyLayout: 'Survey Layout',
      editorLanguage: 'en_US',
      sender: 'Sender',
      feedbackSender: 'State the sender',
      subjectMatter: 'Subject',
      template: 'Template',
      buttonAddTemplate: 'Add template',
      topLogo: 'Top Logo',
      changeLogo: 'Choose another logo',
      buttonChooseFile: 'Choose file',
      noFileSelected: 'No file is selected',
      closingMessageInput: 'Closing Message',
      privacyPolicyInput: 'Privacy Policy',
      anonymousResponseInput: 'Anonymous response',
      anonymousSwitch: 'Enable anonymous',
      alwaysAnonymousSwitch: 'Always enable anonymous',
      addEmail: 'Add email',
      sendTestEmail: 'Submit',
      modalTestSurvey:
        'Validate your layout before sending it to your customers! Fill in your email and see how your customers will receive your customized email.',
      footerInput: 'Footer',
      scale0a10:
        'On a scale of 0 to 10, how likely would you recommend {companyName} to a friend or relative?',
      scale1a5:
        'On a scale of 0 to 5, how likely would you recommend {companyName} to a friend or relative?',
      scaleCSAT1to5:
        'On a scale of 1 to 5, how satisfied are you with our company?',
      scaleCSAT0to10:
        'On a scale of 0 to 10, how satisfied are you with our company?',
      question5Stars: 'How do you rate your service?',
      questionLikeDislike:
        'How do you rate your experience with the service provided?',
      newTemplateEmail: 'New email Template',
      selectSavedTemplate: 'Select saved template',
      feedbackSaveTemplate: 'Enter a name to save your template',
      enterNameTemplate: 'Enter a name for the template',
      saveButton: 'Save',
      createdSucess: 'Template created successfully.',
      cancelButton: 'Cancel',
      preview: 'Preview',
      scaleNps0a10: 'NPS - scale of 0 to 10',
      scaleNps1a5: 'NPS - scale of 1 to 5',
      editButton: 'Edit',
      titleTestLayoutEmail: 'Test Email Layout',
      bodyButtonMsg: 'The button bellow will appear only in the email body',
      rateExperience: 'Rate your experience!',
      enterSubject: 'Enter a subject',
      scaleButton: 'Scale',
      scaleBorder: 'Borders',
      scaleGrade: 'Text button',
      scaleLargeButton: 'Button',
      scaleButtonselected: 'Selection',
      scaleBackground: 'Background',
      scaleBackgroundText: 'Texts',
      scaleActiveText: 'Selected button text',
      messageError: {
        title: 'Oops! Something went wrong...',
        description:
          'Your company does not have a Privacy Policy. Save your action and go to the settings menu to register it.',
        errorEditAction:
          'Something went wrong while trying to edit an action. Please verify data and try again.',
        errorCreateAction:
          'Something went wrong while trying to create an action. Please verify data and try again.',
        errorExceed: 'Message has reached the character limit',
      },
      testEmail: {
        title: 'Success',
        description: 'Test email sent successfully!',
      },
      invalidEmail: {
        title: 'Failure',
        description: 'Enter a valid email',
      },
      failedSendEmail: {
        title: 'Failure',
        description: 'Test submission failed',
      },
      deleteItem: {
        title: 'Warning',
        description:
          'You are about to delete this item, are you sure you want to continue?',
      },
      titleClosingMessage: 'Closing Layout',
      titleAutomaticAnswer: 'Automatic Answer',
      enableSMS: 'Enable response via SMS?',
      smsMessage:
        'On a scale of 0 to 10, what score would you rate our company?',
      feedbackInformQuestionSMS:
        'Please enter the question that will be sent by SMS.',
      feedbackEnterQuestion: 'Please enter a question or remove this field.',
      numMaxQuestions:
        'You have reached the maximum number of additional questions.',
      feedbackEnterOneQuestion: 'Please enter a question.',
      clickHere: 'Click here to access.',
      metrics: 'Metrics',
      review: 'Review',
      csat0a10: 'Scale 0 to 10',
      likert1a5: 'Likert - 1 to 5',
      likeDislike: 'Like/Dislike',
      emotion: 'Emotion',
      csat: 'Scale 1 to 10',
      likert: 'Likert',
      multipleChoices: 'Multiple choice',
      text: 'Text',
      registrationData: 'Registration data',
      label: 'Label',
      multipleChoiceModal: {
        other: 'Others',
        enableOther: 'Enable "Other" option (Open Field)',
        title: 'Multiple answer option',
        description:
          'Fill in the type of single or multiple choice answer and answer options.',
        newOption: 'Option {option}',
        singleChoice: 'Single choice',
        multipleChoice: 'Multiple choice',
      },
      allAnswersRequired: 'Mandatory answer',
      customMandatoryQuestions: 'Mandatory answers per additional question',
      widget: {
        type: 'Type of widget',
        allowedDomain: 'Domain that will use the widget',
        scriptLabel: 'Script to be inserted into your platform',
        name: 'Name',
        phone: 'Phone',
        indicators: 'Indicators',
        copy: 'Copy',
        simulate: 'Simulate',
        copiedTitle: 'Script copied',
        copiedDescription: 'The script has been copied to the clipboard!',
        comment:
          'Only the fields "name", "email", "phone" and "indicators" can be changed in the code above. They are responsible for identifying the customer. ',
        disabled: 'Pause widget',
        paused: 'Widget paused!',
      },
      questionFormatting: 'Display of Questions (Formatting)',
      default: 'Default',
      custom: 'Custom',
      defaultDescription:
        'Aligns and centers additional questions in the middle of the page. Check in preview.',
      customDescription:
        'Align additional questions to the right of the page. Check in preview.',
      typeQuestionLikert: 'Likert question type:',
      satisfied: 'Satisfied',
      agreement: 'Agreement',
      frequency: 'Frequency',
      importance: 'Importance',
      probability: 'Probability',
      viewLikertSelected: 'Selected likert question preview',
    },
    stepTwo: {
      labels: {
        amount: 'Amount',
        schedule: 'Schedule',
        intervalDays: 'Interval in Days',
        type: 'Type',
        periodDays: ' Period in days',
        expirationDays: 'Expiration in days',
        titleAlert: 'Alert Title',
        ruleName: 'Rule Name',
        creationDate: 'Creation date',
        actions: 'Actions',
      },
      enableSMS: 'Enable SMS reminder?',
      msgReminder:
        'When enabled, every reminder will also be sent via SMS. You must have SMS balance available!',
      msgReminderEmailSms:
        'When enabled, all reminders will be sent by E-mail and SMS. SMS balance is required',
      typeMesssage: 'Type message for reminder link',
      mandatory: 'Mandatory',
      titleSetting: 'ALERTS AND TREATMENTS SETTINGS',
      titleQuarantineSetting: 'QUARANTINE SETTINGS',
      titleExpirationDate: 'EXPIRATION DATE',
      titleModelAlert: 'ALERT TEMPLATE',
      selectedRule: 'Rule Selected',
      noRule: 'None',
      noOption: 'None',
      newRule: 'New rule',
      shoot: 'Dispatch',
      answer: 'Answer',
      actionGroup: 'Action Group',
      reminderSetting: 'REMINDER SETTINGS',
      feedbackEnterAlertName: 'Please enter the alert name.',
      infoAlert:
        'The alert will be received in the language answered by the customer',
      feedbackNewAlert: 'You have received a new alert!',
      feedbackIncorrectProduct:
        'I did not recieve the correct product and I am very upset!',
      note: 'Score',
      action: 'Action',
      channel: 'Channel',
      phone: 'Telephone',
      email: 'Email',
      feedbackUserReport: 'The user below reported the following feedback',
      message: 'Message',
      emailJoao: 'joao@gmail.com',
      phoneUser: '(19)99854-1365',
      languageEmail: 'Email language',
    },
    stepThree: {
      actionPaused: 'Cannot send because the action is paused!',
      labels: {
        addIndicators: 'Add indicators',
        personName: 'Name',
        personEmail: 'Email',
        personPhone: 'Telephone',
      },
      titleIndicators: 'Indicators',
      titleLayout: 'FILE LAYOUT',
      titleClearTable: 'Clear customer table',
      titleImportData: 'IMPORT DATA',
      titleInsertCustomer: 'Insert customer',
      titleScheduling: 'SCHEDULING',
      titleAddIndicator: 'Inclusion of Indicator',
      shootNow: 'Dispatch now',
      scheduleShooting: 'Schedule dispatch',
      shoot: 'Dispatch',
      toSchedule: 'To Schedule',
      settingsSaved: 'Settings of this Action Saved!',
      skipImport: 'Proceed to import',
      wish: 'What do you wish to do now?',
      continueAfter: 'Continue Later',
      cancel: 'Cancel',
      importCustomersXLS: 'Import customers via XLS file',
      informFieldName: 'State {nameField} field',
      informFieldEmail: 'State {emailField} field',
      informFieldPhone: 'State {emailPhone} field',
      failedAddCustomer: 'Failure to include customer.',
      importFile: 'Import File',
      dragFile: 'Click here or drop file up to here',
      dropFile: 'Drop file here...',
      insertCustomers: 'Insert customers manually',
      enterIndicatorsName: 'Type in the indicator name',
      itens: 'Items',
      buttonAddColumn: 'Add',
      downloadModelButton: 'Download template',
      addedIndicators: 'Added Indicators',
      indicator: 'Indicator',
      remove: 'Remove',
      generateQrCode: 'Generation of the Qr Code',
      uniqueQrCode: 'Unique QR Code',
      uniqueQrCodeDescription:
        'With the generated code, your customer will be able to scan through the cell phone camera and be directed to the survey page. This model is ideal for simpler research cases, where there is no need to identify a particular product or service.',
      multipleQrCode: 'Multiple QR Code',
      multipleQrCodeDescription:
        'With the generated code, your customer will be able to scan through the cell phone camera and be directed to the survey page. This model is ideal for research cases where there is a need to generate several QR Codes for the same action and where there is a need to identify a particular product, service or unit with different codes.',
      downloadQrCode: 'Download QR Code',
      importValueQrCode: 'Import value via XLS file',
      enterValueManually: 'Enter value manually',
      generateQrCodeButton: 'Generate QR Code',
      viewQrCodes: 'View Generated QR Codes',
      generatedQRCodes: 'Generated QR Codes',
      descriptionGeneratedQrCodes:
        'Below is the list of all generated codes that can be used for your search.',
      savedQrCodes: 'Saved QR Codes',
      backListActions: 'Back to list of actions',
      invalidIdField:
        'It is not possible to include a field with the name id for the QR Code.',
      deleteQrcode: 'Delete QR Code',
      deleteQrcodeDescription:
        'Are you sure you want to delete the QR Code? It will no longer be possible to answer surveys through this link. ',
      qrcodeTableOptions: 'Options',
      indicatorHeaders: {
        filial: {
          header: 'Branch',
          content:
            'Name of stores, branches, units. This indicator can be used for user hierarchy by assigning permission to certain branches.',
        },
        ih2: {
          header: 'IH2',
          content:
            'Hierarchy 2 (IH2) indicator can be used for departments, groups, etc., its main function is assigning permission per user.',
        },
        report: {
          header: 'Report',
          content:
            'Report type indicators are indicators that are used for detailed analysis in reports, they create breaks in reports according to the data in the indicator.',
        },
        map: {
          header: 'Map',
          content:
            'Map type should be filled in UF (state) with two letters, this indicator will fill in a color map according to the main score and Brazilian state.',
        },
        date: {
          header: 'Date',
          content:
            'Date type indicator should be selected as this type to remain in the correct format of mm/dd/yyyy',
        },
        auxiliary: {
          header: 'Auxiliary',
          content: `Indicators for viewing in detail, but without breaking by report, ex: invoice number, cnpj customer, customer code, dates, etc. are indicatores that we don't use for reporting views.`,
        },
        clientId: {
          header: 'Client ID',
          content: 'identification key for unique customer.',
        },
        expiration: {
          header: 'Expiration Date',
          content:
            'Expiration Date type indicator must be filled in format dd/mm/aaaa',
        },
      },
      messages: {
        warning: {
          title: 'Attention!',
          description:
            'Triggering was performed via {channel1} only. You have no enough balance to fire via {channel2}. Please contact the IndeCX CS team for more information.',
        },
        exceeded: {
          title: 'Insufficient Funds!',
          description:
            'Insufficient funds for dispatch! You are trying to dispatch {totalInvites} invitations and have a balance of  {balanceMsg} . Please contact the IndeCX CS support team for more information.',
        },
        shots: {
          title: 'Dispatch Updated!',
          description:
            'You will be redirected to your action list to track the dispatch status.',
        },
        dangerMode: {
          title: 'Oops... Something went wrong!',
          description:
            'There was a problem while adding this type to the indicator.',
        },
        removeColumn: {
          title: 'Deactivate indicator',
          description: 'Are you sure your want to deactivate this indicator?',
        },
        errorMessage: {
          title: 'Error adding customer',
          description: 'There was an error processing your request.',
        },
        success: {
          title: 'Success!',
          description: 'Indicator has been deactivated!',
        },
        deleteList: {
          title: 'Delete List',
          description:
            'Are you sure you want to delete this list of customers?',
        },
        emailInvalid: {
          title: 'Invalid email',
          description: 'Please enter a valid email address.',
        },
        addClientSuccess: {
          title: 'Success',
          description: 'Customer successfully added!',
        },
        errors: {
          invalidColumn:
            'It is not possible to have two columns with the same name.',
          invalidNumber: 'Please enter a valid number for customer.',
          invalidCharacters: '. and $ characters are not allowed in name',
        },
      },
    },
  },
  actionGroup: {
    pageTitle: 'Action Group',
    searchInput: 'Search...',
    searchButton: 'Clear',
    groupTable: {
      labels: {
        id: 'ID',
        name: 'Name',
        metric: 'Metric',
        favourite: 'Favorite',
        actions: 'Associated actions ',
        options: 'Options',
      },
    },
    newGroupButton: 'New group',
    editGroup: 'Edit group',
    newGroup: 'New group',
    save: 'Save',
    groupName: 'Group Name',
    placeholderGroupName: 'Enter group name',
    metric: 'Metric',
    favoriteGroup: 'Favorite Group',
    nps010: 'NPS 0 to 10',
    nps15: 'NPS 1 to 5',
    csat15: 'CSAT 1 to 5',
    ces15: 'CES 1 to 5',
    csatAverage15: 'CSAT(average) 1 to 5',
    csat0to10Average: 'CSAT 0 to 10(Average)',
    fiveStars: '5-Stars',
    messages: {
      saveError: {
        title: 'Oops...',
        description: 'Please enter a name for the group.',
      },
      edited: {
        title: 'Group updated!',
        description: 'Group updated successfully!',
      },
      created: {
        title: 'Group registered!',
        description: 'New group registered successfully!',
      },
      favorite: {
        title: 'Are you sure?',
        description1: 'Do you wish to unfavorite this group?',
        description2: 'Do you wish to favorite this group?',
      },
      favoriteOk: {
        title1: 'Group became unfavorite!',
        title2: 'Group became favorite!',
        description1: 'This group is no longer your favorite.',
        description2: 'This group is now your favorite.',
      },
      deleted: {
        title: 'Are your sure?',
        description: 'Do you wish to delete this group?',
      },
      deletedOk: {
        title: 'Group deleted!',
        description: 'Group has been deleted.',
      },
    },
  },
  answers: {
    pageTitle: 'Answers',
    searchInput: 'Search...',
    searchButton: 'Clear',
    email: 'Email',
    telephone: 'Telephone',
    channel: 'Channel',
    action: 'Action',
    metric: 'Metric',
    exportCsv: 'Export to CSV',
    exportXls: 'Export to XLSX',
    csvCommaSeparator: 'Separate by comma',
    csvPipeSeparator: 'Separate by pipe',
    analyticsDownload: 'BI Analytics',
    categoriesDownload: 'Categories',
    answersDownload: 'Answers',
    feedbackEdited: 'Comment edited by {feedbackEditedAutor}',
    editComment: 'Edit Comment',
    editComentary: `You can edit the customer's comment to add some consideration to the text.`,
    nobody: 'Nobody',
    addQuestions: 'Additonal Questions',
    details: 'Details',
    removeAnswer: 'Remove Answer',
    cancel: 'Cancel',
    remove: 'Remove',
    removeSuccess: 'Answer removed successfully!',
    ops: 'Oops...',
    categorization: 'Categorization',
    categorizationGol: 'Categorization Input',
    foundAnswer: 'found answer',
    infoAnswer: 'Information',
    gradeAnswer: 'Grade',
    ratingAnswer: 'Rating',
    nameAnswer: 'Name',
    emailAnswer: 'Email',
    phoneAnswer: 'Phone',
    channelAnswer: 'Channel',
    actionAnswer: 'Action',
    metricAnswer: 'Metric',
    feedbackAnswer: 'Feedback',
    categoryAnswer: 'Category',
    nextAnswer: 'Next Answer',
    previousAnswer: 'Previous Answer',
    noAnswersFound: 'No answers found.',
    donwload: {
      title: 'Success!',
      description:
        'The file is being prepared! You can track the processing status in the "Downloads" menu.',
    },
    deleteAnswer: {
      title: 'Delete Answer',
      description:
        'Are you sure you want to delete this answer? This may directly affect your NPS calculation.',
    },
    deleteCategory: {
      title: 'Remove Category',
      description: 'Are you sure you want to delete this category?',
    },
    categoryDelSuccess: 'Category removed successfully!',
    profileSelect: {
      select: 'Filter by profile',
      all: 'All',
      promoters: 'Promoters',
      neutral: 'Neutrals',
      detractors: 'Detractors',
    },
    channelSelect: {
      select: 'Filter por channel',
      all: 'All',
      email: 'Email',
      sms: 'SMS',
      link: 'Link',
      qrcode: 'QR-Code',
      manual: 'Manual',
      widget: 'Widget',
      whatsapp: 'Whatsapp',
      treatmentTags: 'Treatment tags',
    },
    categorySelect: {
      select: 'Filter by category',
      all: 'All',
      empty: 'No category (empty)',
    },
    responsibleSelect: 'Select the responsible',
    treatmentSelect: 'Select',
    filterOptions: {
      select: 'Select the filter',
      profile: 'Profile',
      status: 'Status',
      category: 'Category',
      responsible: 'Responsible',
      notification: 'Notification',
      channel: 'Channel',
      comments: 'Comements',
      anonymous: 'Anonymous',
      treatmentTags: 'Treatment tags',
      addQuestion: 'Additional question',
      sentiment: 'Sentiment',
      audio: 'Audio',
      partial: 'Partial response',
      recordedAudio: 'Recorded Audio',
    },
    sentiment: {
      positive: 'Positive',
      negative: 'Negative',
      neutral: 'Neutral',
    },
    notificationSelects: {
      viewed: 'Viewed',
      noViewed: 'No Viewed',
    },
    commentsSelect: {
      select: 'Filter by comment',
      all: 'All',
      withComments: 'Only with comment',
      noComments: 'Only without comment',
    },
    anonymousSelect: {
      select: 'Select a filter',
      all: 'All',
      anonymous: 'Anonymous',
      yes: 'Yes',
      no: 'No',
    },
    recordedAudio: {
      select: 'Select a filter',
      all: 'All',
      anonymous: 'Anonymous',
      yes: 'Yes',
      no: 'No',
    },
    justCommentsLable: 'Only with comment',
    answerTable: {
      labels: {
        id: 'Id',
        date: 'Date',
        grade: 'Score',
        client: 'Customer',
        comment: 'Comment',
        category: 'Categories',
        options: 'Options',
        tags: 'Tags',
      },
    },
    answersDetails: {
      details: 'Details',
      historic: 'History of',
      note: 'Score',
      channel: 'Channel',
      action: 'Action',
      comment: 'Comment',
      search: 'Do your search...',
      sentimentAnalyze: 'Sentiment analyze',
      transferSuccess: 'Transfer successful',
      transferError: 'Transfer error',
      transferErrorMessage:
        'There was an error in the transfer. Please try again in a moment',
      branchSearchDescription:
        'You can transfer a survey between branches if necessary. Select below which branch you want to transfer this search to.',
      transferFactoryAccount: 'Transfer to factory account',
      transferAffiliateSearch: 'Transfer affiliate search',
      transferBetweenShares: 'Transfer research between actions',
      sentimentMsg:
        'A IndeCX utiliza Inteligência Artificial para classificação do sentimento e extração de palavras-chaves com base nos comentários. O score abaixo indica o nível do sentimento, podendo variar de -100 até 100.',
      sentiment: 'Sentiment',
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
      keywords: 'Keywords',
      email: 'Email',
      phone: 'Telephone',
      date: 'Date',
      categories: 'Categories',
      indicators: 'Indicators',
      none: 'None',
      additionalQuestions: 'Additional questions',
      treatments: {
        status: 'Status',
        responsible: 'Responsible for Treatment',
        changeStatus: 'Change Status',
        selectOpenStatus: 'Open',
        selectAnalisysStatus: 'Analyzing',
        selectEscalatedStatus: 'Dispatching',
        selectAnsweredStatus: 'Answered',
        changeResponsible: 'Change Responsible',
        veryUnsatisfied: 'Very unsatisfied',
        dissatisfied: 'Unsatisfied',
        indifferent: 'Indifferent',
        satisfied: 'Satisfied',
        verySatisfied: 'Very Satisfied',
        anonymous: 'Anonymous',
        noName: 'No Name',
        back: 'Back',
        feed: 'Feed',
        updateTemplate: 'Update Template',
        deleteTemplate: 'Delete template',
        addCommentary: 'Add comment',
        nobody: 'Nobody',
        dataAction: 'Action Data',
        treatment: 'Treatments',
        treatmentTabLabel: 'TREATMENT',
        answerTabLabel: 'ANSWER',
        selectFilterTreatments: 'Select filter',
        systemAlert: 'System alert',
        commentFilterTreatments: 'Comment',
        statusFilterTreatments: 'Status',
        responsibleFilterTretaments: 'Responsible',
        allFilterTreatments: 'All',
        mostRecent: 'Most recent',
        mostOld: 'Most old',
        to: 'To',
        subject: 'Subject',
        from: 'From',
        template: 'Plantilla',
        send: 'Send',
        swAdd: {
          title: 'Comment Added!',
          description: 'Your comment has been added to this treatment',
        },
        swAddError: {
          title: 'Oops! Something went wrong!',
          description: 'Try again later!',
        },
        swSave: {
          title: 'Success!',
          description:
            'The additional information has been saved successfully!',
        },
        swResponsible: {
          title: 'Responsible person Changed!',
          description:
            'A new responsible person has been selected for this treatment.',
        },
        swStatus: {
          title: 'Status Updated!',
          description: 'The status of this treatment has been updated to',
        },
        swExceededQuantity: {
          title: 'File limit reached!',
          description: 'The maximum amount of 5 files has been reached.',
        },
        enterContact: 'Contacted the customer',
        yes: 'Yes',
        no: 'No',
        whatChannel: 'By which channel was the contact made?',
        wpp: 'Whatsapp',
        phone: 'Phone',
        email: 'Email',
        personally: 'Personally',
        others: 'Others',
        caseDifficult:
          'If you had difficulties with the parts of this service, please inform:',
        saveInfo: 'Save information',
        pieceNumber: 'Part number',
        pieceName: 'Part name',
        price: 'Price',
      },
    },
    filterTypeOptions: {
      email: 'Email',
      id: 'ControlID',
      name: 'Name',
      phone: 'Phone',
      feedback: 'Comment',
      clientId: 'ClientID',
    },
    entirePeriodWarning: {
      title: 'Warning!',
      description: 'Please enter a shorter period.',
    },
  },
  manualAnswer: {
    pageTitle: 'Manual Survey',
    searchInput: 'Search...',
    searchButton: 'Clear',
    invitesTable: {
      labels: {
        id: 'ID',
        action: 'Action',
        client: 'Customer',
        submit: 'Send',
        reminder: 'Reminder',
        days: 'Days',
        channel: 'Channel',
        status: 'Status',
        manual: 'Manual Answer',
      },
    },
    metric: 'Metric',
    nps010: 'NPS 0 to 10',
    nps15: 'NPS 1 to 5',
    ces15: 'CES 1 to 5',
    csat15: 'CSAT 1 to 5',
    csatAverage15: 'CSAT(Average) 1 a 5',
    csat0to10Average: 'CSAT 0 to 10 (Average)',
    likeDislike: 'Like/Dislike - 0 and 1',
    fiveStars: '5-Stars',
    noName: 'No Name',
    email: 'Email',
    phone: 'Telephone',
    both: 'both',
    active: 'Active',
    expired: 'Expired',
    updateInvite: 'Update Invitation',
    noInvite: 'Invitation not available.',
    messages: {
      refresh: {
        title: 'Reactivate Invitation',
        description: 'Are you sure you want to reactivate customer invitation?',
        okLabel: 'Reactivate',
        cancelLabel: 'Cancel',
      },
      answeredSearch: {
        title: 'Survey Answered',
        description: 'The survey has been answered manually for the customer.',
      },
      unansweredSurvey: {
        title: 'Unanswered Survey',
        description: 'Please enter a rating of 0 to 10.',
      },
      required: 'Please answer all required questions.',
    },
  },
  sentiment: {
    pageTitle: 'Sentiment Analyze',
    sentimentSelect: {
      select: 'Filter by sentiment',
      all: 'All',
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
    },
    table: {
      sentiment: 'Reaction',
      score: 'Sentiment',
      keywords: 'Keywords',
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
      options: 'Visualize',
    },
  },
  clients: {
    pageTitle: 'Customers',
    searchInput: 'Search...',
    searchButton: 'Clear',
    exportCsv: 'Export to CSV',
    exportXls: 'Export to XLS',
    csvCommaSeparator: 'Separate by comma',
    csvPipeSeparator: 'Separate by pipe',
    messages: {
      export: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
      },
      error: {
        title: 'Oops...',
      },
      entirePeriodWarning: {
        title: 'Warning!',
        description: 'Please enter a shorter period.',
      },
    },
    clientsTable: {
      labels: {
        id: 'ID',
        name: 'Name',
        email: 'Email',
        phone: 'Telephone',
        lastAction: 'Action',
        lastImportation: 'Importation',
        lastInvite: 'Last invitation',
        lastAnswer: 'Last answer',
        status: 'Status',
        answered: 'Answered',
        lastReminder: 'Last Reminder',
        reminders: 'Reminders',
        editReminder: 'To edit',
      },
      searchOptions: {
        email: 'Email',
        id: 'ControlID',
        name: 'Name',
        phone: 'Phone',
        clientId: 'ClientID',
      },
      answeredYes: 'Yes',
      answeredNo: 'No',
      statusYes: 'Active',
      statusNo: 'Inactive',
    },
  },
  quarentines: {
    pageTitle: 'Quarentine',
    searchInput: 'Seaarch...',
    searchButton: 'Clear',
    totalQuarentine: 'Total customers in quarentine',
    exportCsv: 'Export to CSV',
    exportXls: 'Export to XLS',
    csvCommaSeparator: 'Separate by comma',
    csvPipeSeparator: 'Separate by pipe',
    messages: {
      export: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
      },
      error: {
        title: 'Oops... Something went wrong!',
        description: 'Please, try again later!',
      },
      removeOk: {
        title: 'Success!',
        description: 'Quarentine removed successfully',
      },
      removeQuarentine: {
        title: 'Remove quarentine',
        description: 'Are you sure you want to delete this quarentine?',
        ok: 'Quarentine removed successfully',
      },
    },
    action: 'Action',
    company: 'Company',
    quarentinesTable: {
      labels: {
        email: 'E-mail',
        phone: 'Phone',
        clientId: 'ClientId',
        type: 'Type',
        action: 'Action',
        quarentineDate: 'Quarentine Date',
        expireDate: 'Expires in',
        actions: 'Actions',
      },
    },
  },
  blacklist: {
    totalBlacklist: 'Total blocklisted customers',
    addClient: 'Add customer',
    searchInput: 'Search...',
    searchButton: 'Clear',
    pageTitle: 'Blocklist',
    labelsTable: {
      email: 'E-mail',
      phone: 'Phone',
      controlId: 'ControlId',
      action: 'Action',
      reason: 'Reason',
      blackListDate: 'Date Blocklist',
      actions: 'Actions',
      channel: 'Channel',
    },
    csvCommaSeparator: 'Separate by comma',
    csvPipeSeparator: 'Separate by pipe',
    messages: {
      export: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
      },
      error: {
        title: 'Oops... Something went wrong!',
        description: 'Please, try again later!',
      },
      removeOk: {
        title: 'Success!',
        description: 'BlackList removed successfully',
      },
      removeBlackList: {
        title: 'Remove blacklist',
        description: 'Are you sure you want to delete this blacklist?',
        ok: 'BlackList removed successfully',
      },
    },
  },
  downloads: {
    pageTitle: 'My downloads',
    clients: 'Customers',
    answers: 'Answers',
    invites: 'Invitations',
    invitesStatus: 'Invites Status',
    answerIndicators: 'Answer (Indicador)',
    reminders: 'Reminders',
    scheduling: 'Schedulings',
    trash: 'trash',
    answerDetails: 'Action Details',
    quarentine: 'Quarentine',
    blackList: 'BlockList',
    analytics: 'BI Analytics',
    category: 'Categories',
    consumption: 'Consumption',
    action: 'Actions',
    downloading: 'downloading',
    internalError: 'Internal Error.',
    fileNotFound: 'File not found.',
    errorTitle: 'Oops...',
    finished: 'finished',
    notificationTitle: 'Warning',
    notificationText: `Upload system accepts only files with the same layout of the selected action.
      Please, verify if the file has exactly the same columns and if the columns are int same order,
      according to the action configuration"`,
    selectReferenceLabel: 'Type',
    referenceSales: 'Sales',
    referenceAftersales: 'Aftersales',
    downloadsTable: {
      labels: {
        id: 'ID',
        date: 'Date',
        type: 'Type',
        extension: 'Extension',
        status: 'Status',
        file: 'File',
      },
    },
    invalidDownload: {
      title: 'File not available!',
      description:
        'The file no longer exists. Please generate another download and try again.',
    },
  },
  uploads: {
    pageTitle: 'My uploads',
    errorTitle: 'Oops...',
    fillFields: 'Please fill all fields',
    sendFile: 'Send File',
    modalTitle: 'Send File',
    branchLabel: 'Select Branch',
    referenceLabel: 'File Reference',
    actionLabel: 'Select Action',
    fileLabel: 'Select File',
    attachFile: 'Attach file',
    indicatorsError: 'Incorrect file format',
    notificationTitle: 'Important',
    notificationText: `Upload system accepts only files with the same layout
      of the select action. Verify if the selected file contains the same
      columns amount and if the columns order is according to
      previously configured in the action`,
    selectReferenceLabel: 'Type',
    referenceSales: 'Sales',
    referenceAftersales: 'Aftersales',
    selectLabel: 'Select',
    selectPlaceholder: 'Choose a file or drop it here...',
    dropPlaceholder: 'Drop the file here',
    uploadsTable: {
      labels: {
        id: 'ID',
        user: 'User',
        date: 'Date',
        file: 'File',
        branch: 'Branch',
        action: 'Action',
        reference: 'Reference',
        options: 'Options',
        remove: 'Remove',
        download: 'Download',
      },
    },
    removeUpload: {
      title: 'Remove file',
      description: 'Are you sure you want to remove this file?',
      ok: 'File removed successfully',
    },
  },
  resend: {
    pageTitle: 'Resend survey (Active invites)',
    pageTitlewpp: 'Manual survey resend by Whatsapp',
    searchInput: 'Search...',
    searchButton: 'Clear',
    selectPage: 'Select page',
    selectsInfo: {
      clientsLength: '{length} customers were selected for resending.',
      selectAll: 'Select all {length} customers.',
      allClients: 'All {length} customers were selected.',
      cleanSelection: 'Clear selection.',
    },
    invitesTable: {
      labels: {
        id: 'ID',
        action: 'Action',
        client: 'Customer',
        submit: 'Submit',
        resend: 'Last Resend',
        reminder: 'Reminder',
        days: 'Days',
        channel: 'Channel',
        link: 'Link',
        select: 'Select',
        message: 'Message',
        copy: 'Copy',
        lastSend: 'Last Send',
      },
    },
    cancelInvitesButton: 'Cancel Invitations',
    resendButton: 'Resend',
    metric: 'Metric',
    nps010: 'NPS 0 to 10',
    nps15: 'NPS 1 to 5',
    noName: 'No Name',
    email: 'Email',
    phone: 'Telephone',
    both: 'both',
    copyLink: 'Copy Link',
    exportCsv: 'Export to CSV',
    exportXls: 'Export to XLS',
    sendWpp: 'Resend via WhatsApp',
    whatsappWebMsg: 'Send survey link by WhatsApp',
    send: 'Send',
    name: 'Name',
    messages: {
      copyUrl: {
        title: 'Link Copied',
        description: `Customer's link has been copied to the clipboard.`,
      },
      copyMsg: {
        title: 'Mensage Copied',
        description: 'The message has been copied to the clipboard.',
      },
      sendNoClient: {
        title: 'No Customer Selected',
        description:
          'You should select at least one customer to resend a survey.',
      },
      sendAllInvites: {
        title: 'Resend Survey',
        description:
          'Are you sure you want to resend the survey to all the selected customers?',
        yesLabel: 'Yes',
        noLabel: 'No',
        sentMsg1: 'Survey has been successfully sent to',
        sentMsg2: 'customer(s) from',
        sentMsg3: 'selected!',
        sentMsgOk:
          'Survey has been resent successfully to selected customer(s)!',
      },
      sendInvites: {
        title: 'Resend Survey',
        description1: 'Are you sure you want to resend the survey to',
        description2: 'customer(s)',
        yesLabel: 'Yes',
        noLabel: 'No',
        sentMsg1: 'Survey has been successfully resent to',
        sentMsg2: 'customer(s) of',
        sentMsg3: 'selected!',
        sentMsgOk:
          'Survey has been successfully resent to selected customer(s)!',
      },
      warning: {
        title: 'Attention!',
        description:
          'Triggering was performed via {channel1} only. You have no balance to fire via {channel2}. Please contact the IndeCX CS team for more information.',
      },
      noQuota: {
        title: 'Insufficient Funds!',
        description1:
          'Insufficient Funds for dispatch! You are trying to dispatch',
        description2: 'Invitations and you have',
        description3:
          'balance. Please contact the IndeCX CS team for more information',
        description:
          'Insufficient balance to trigger! You are trying to trigger {totalInvites} invites and you have {balanceMsg} balance. Please contact the IndeCX CS team for more information.',
      },
      quotaError: {
        title: 'Insufficient Funds!',
        description:
          "You don't have enough balance to trigger via {channel}. Please contact the IndeCX CS team for more information.",
      },
      cancelNoClient: {
        title: 'No Customer Selected',
        description: 'You should select at least one invitation to cancel.',
      },
      cancelAllInvites: {
        title: 'Cancel Invitations',
        description:
          'Are you sure you want to cancel invitations for all selected customers?',
        yesLabel: 'Yes',
        noLabel: 'No',
        cancelMsgOk:
          'Invitations were succesffully cancelled for selected customers!',
      },
      cancelInvites: {
        title: 'Cancel invitations',
        description1: 'Are you sure you want to cancel invitations for',
        description2: 'customer(s)?',
        yesLabel: 'Yes',
        noLabel: 'No',
        cancelMsgOk:
          'Invitations were successfully cancelled for selected customers!',
      },
      export: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
        errorTitle: 'Oops...',
      },
    },
  },
  reminders: {
    pageTitle: 'Reminders',
    searchInput: 'Search...',
    searchButton: 'Clear',
    selectPage: 'Select page',
    channelFilter: {
      select: 'All channels',
      email: 'Email',
      sms: 'SMS',
      all: 'Email and SMS',
    },
    selectInfo: {
      remindersLength:
        'You have selected {length} reminder(s) to be cancelled.',
      selectAll: 'Select all the {length}.',
      allReminders: 'You have selected {length} reminder(s) to be cancelled.',
      cleanSelection: 'Clear selection.',
    },
    remindersTable: {
      labels: {
        id: 'ID',
        action: 'Action',
        client: 'Customer',
        date: 'Date of Reminder',
        channel: 'Channel',
        cancel: 'Cancel reminders',
      },
    },
    cancelRemindersButton: 'Cancel reminders',
    updateList: 'Update List',
    messages: {
      sendNoReminder: {
        title: 'Oops...',
        description: 'You should choose at least one reminder to cancel.',
      },
      send: {
        title: 'Cancel reminders',
        description:
          'Are you sure you want to cancel the selected reminder(s)?',
      },
      sendError: {
        title: 'Error',
        description: 'Something went wrong',
      },
      download: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
      },
      downloadError: {
        title: 'Oops! Something went wrong...',
      },
    },
  },
  scheduling: {
    pageTitle: 'Schedules',
    searchInput: 'Search...',
    searchButton: 'Clear',
    selectPage: 'Select Page',
    channelFilter: {
      select: 'All Channels',
      email: 'Email',
      sms: 'SMS',
      all: 'Email and SMS',
    },
    selectInfo: {
      schedulingLength:
        'You have selected {length} schedule(s) to be cancelled.',
      selectAll: 'Select all the {length}.',
      allSchedulings: 'You have selected {length} schedule(s) to be cancelled.',
      cleanSelection: 'Clear select.',
    },
    schedulingTable: {
      labels: {
        id: 'ID',
        action: 'Action',
        client: 'Customer',
        date: 'Schedule Date ',
        channel: 'Channel',
        cancel: 'Cancel schedules',
      },
    },
    messages: {
      cancelNoSelect: {
        title: 'Oops...',
        description: 'You should select at least one schedule to cancel.',
      },
      cancelQuestion: {
        title: 'Cancel schedule',
        description: 'Are you sure you want to cancel the selected schedules?',
      },
      cancelError: {
        title: 'Error',
        description: 'There was a problem',
      },
      download: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
      },
      maxDownloadError: {
        title: 'Too many records!',
        description:
          'Too many records for Downloading. Please, contact IndeCX support for this operation',
      },
      downloadError: {
        title: 'Oops! Something went wrong...',
      },
    },
    cancelRemindersButton: 'Cancel schedules',
  },
  trash: {
    actionsMenu: {
      title: 'Actions',
      actionsTable: {
        labels: {
          action: 'Action',
          date: 'Exclusion Date',
          user: 'User',
          restore: 'Restore',
        },
      },
    },
    answersMenu: {
      title: 'Answers',
      searchInput: 'Search...',
      searchButton: 'Clear',
      answersInfo: 'Answer information',
      answersRestore: 'Restore Answers',
      exportXLS: 'Export to XLS',
      swExport: {
        title: 'Success!',
        description:
          'File is being prepared! You can track the processing status in the "Downloads" menu.',
      },
      swError: {
        title: 'Oops',
      },
      swQuestion: {
        title: 'Are you sure?',
      },
      swAction: {
        description: 'Do you really wish to restore this action?',
      },
      swAnswer: {
        description: 'Do you really wish to restore this answer?',
      },
      swRestore: {
        description: 'Action has been restored',
      },
      answersTable: {
        labels: {
          action: 'Action',
          id: 'Survey ID',
          date: 'Exclusion Date',
          user: 'User',
          client: 'Customr',
          email: 'Email',
          phone: 'Phone',
          feedback: 'Feedback',
          reason: 'Reason for Exclusion',
          options: 'Options',
        },
      },
    },
  },
  treatments: {
    pageTitle: 'Individual treatments',
    pageSubTitle:
      'In this module you can handle each customer individually dynamically.',
    filterRullers: 'Order of dealings based on the rule:',
    scheduleClient: 'Scheduled customer:',
    modifyComment: 'Modify Comment',
    registerCategory: 'Register a Category',
    here: 'here.',
    searchDropdown: 'Search',
    product: 'Product',
    attendance: 'Customer Service',
    term: 'Term',
    delivery: 'Delivery',
    responseInformation: 'Response information of',
    close: 'Close',
    note: 'Score',
    channel: 'Channel',
    email: 'Email',
    phone: 'Telephone',
    none: 'None',
    date: 'Date',
    comment: 'Comment',
    additionalQuestions: 'Additional Questions',
    anonymous: 'Anonymous',
    noName: 'No Name',
    promoters: 'promoters',
    neutral: 'neutral',
    detractors: 'detractors',
    invalid: 'invalid',
    system: 'System',
    alertEmail: 'Alert Email sent to {itemChange}.',
    statusUpdate: 'Status changed to {itemChange}.',
    answerCategory: 'Response categorized as {itemChange}.',
    removedCategory: 'Category {itemChange} removed for response.',
    newComment: 'New comment added for response: {itemChange}',
    responsibleDealt: 'Responsible for treatment changed {itemChange}.',
    responseCollected: 'This response has been collected by {itemChange}',
    resurveySubmitted: 'Repesquisa disparada com sucesso!',
    removedAnswer: 'Answer removed',
    restoredAnswer: 'Answer restored',
    resurveyScheduled: 'Successfully scheduled re-search.',
    transfer: 'Branch transfer',
    options: 'Options',
    userReplyTratativa: 'User answered the treatment',
    unreadTratativa: 'Have unread treatment',
    messages: {
      updateComment: {
        title: 'Comment Updated!',
        description: 'Your comment has been updated',
      },
      errorUpdateComment: {
        title: 'Oops! Something went wrong!',
        description: 'Try again later!',
      },
    },
    indicators: 'Indicators',
    overview: {
      total: 'Total',
      answered: 'Answered',
      opened: 'Opened',
      staggered: 'Dispatches',
      analysis: 'Analyzing',
    },
    statusSelect: {
      select: 'Filter per status',
      all: 'All',
      answered: 'Answered',
      analysis: 'Analyzing',
      staggered: 'Dispatches',
      opened: 'Opened',
    },
    treatmentTable: {
      labels: {
        id: 'ID',
        date: 'Date',
        grade: 'Score',
        client: 'Customer',
        comment: 'Comment',
        responsible: 'Responsible',
        category: 'Categories',
        status: 'Status',
        days: 'Duration',
        options: 'Options',
      },
      dropdown: {
        options: {
          answered: 'Answered',
          analysis: 'Analyzing',
          staggered: 'Dispatched',
          opened: 'Opened',
        },
        status: {
          aberto: 'Opened',
          respondido: 'Answered',
          em_analise: 'Analyzing',
          escalonada: 'Dispatched',
          expirado: 'Expired',
          resp_fora_prazo: 'Resp. Out of time',
        },
      },
    },
    resurveyWarning: {
      title: 'There is a resurvey set up!',
      description:
        'This action will automatically generate a new "resurvey" trigger for this customer and it will not be possible to change the status again. Do you want to change the status to answered and trigger the resurvey?',
      cancelButton: 'Cancel',
      saveButton: 'Change status',
    },
  },
  closetheloop: {
    steps: {
      selectAnswers: 'Select Answers',
      configTemplate: 'Configure template',
      reviewSubmission: 'Review Submission',
    },
    selectAnswers: {
      answersLength: 'You selected {length} response(s) to close the loop.',
      selectAll: 'Select All',
      allSelected:
        'You have selected {totalAnswers} responses for closing the loop.',
      cleanSelection: 'Clear selection',
      validationText: 'Please select at least one answer',
      selectLabel: 'Select',
      closureType: 'What kind of closing would you like to do?',
      byEmail: 'By email',
      onlyStatus: 'Deal status only',
    },
    configureTemplate: {
      emailSubject: 'Subject',
      emailSubjectPlaceholder: 'Enter the subject of the email',
      emailSender: 'Sender',
      emailSenderPlaceholder: "Enter the sender's name",
      templateDescription:
        'Configure and save your templates so that you can use them again quickly and conveniently.',
      myTemplatesTitle: 'My templates',
      myTemplatesDescription:
        'Select a template below to view the email formatting and make changes if necessary.',
      selectTemplate: 'Select a template',
      saveTemplate: 'Save templates',
      saveTemplatePlaceholder: 'Enter template name',
      saveButton: 'Save',
      templatedCreatedTitle: 'Success!',
      templatedCreatedDescription: 'The new template was created successfully!',
      statusTitle: 'Loop close status',
      statusDescription:
        'Please select below what will be the default status of responses after sending the email.',
      responsibleTitle: 'Responsible',
      responsibleDescription:
        'After the trigger is carried out, the user will be automatically assigned as responsible for these negotiations.',
      errorDescription: 'Enter the e-mail subject and sender.',
      saveErrorDescription:
        'Enter the template name, the e-mail subject and the sender.',
    },
    reviewSubmission: {
      description:
        'Review the data below before submission and make sure the filters applied are correct. Once the email has been triggered, it is not possible to cancel the process.',
      answersTotal: 'Total impacted customers',
      appliedFilters: 'Applied filters',
      action: 'Action',
      metric: 'Metric',
      startDate: 'Start date',
      endDate: 'End date',
      allPeriod: 'Every period',
      search: 'Search',
      ih1: 'Branch',
      ih2: 'IH2',
      profile: 'Profile',
      indicator: 'Indicator',
      configTemplate: 'Configured Template',
      sendStatus: 'Status per send',
      responsible: 'Responsible',
      category: 'Category',
      subCategory: 'Subcategory',
      comment: 'Comment',
      anonymous: 'Anonymous',
      submitTitle: 'Success!',
      submitDescription:
        'The close the loop is being fired and shortly selected customers will receive the email.',
    },
    nextButon: 'Next',
    goBackButton: 'Back',
    sendButton: 'Send',
  },
  reports: {
    npsPonder: {
      reportTitle: 'NPS Pondered',
      action: 'Action',
      groupAction: 'Group Action',
      channel: 'Channel',
      weight: 'Weight',
      answers: 'Answers',
      promoters: 'Promoters',
      passive: 'Neutrals',
      detractors: 'Detractors',
    },
    hts: {
      reportTitle: 'HTS Report',
    },
    selectReport: 'Select a report',
    emptyMsg: 'Select a report view in the list',
    pageTitle: 'Reports',
    subTitle: 'Report',
    searchInput: 'Search...',
    searchButton: 'Clear',
    selectProfile: 'Select a profile',
    answersLabel: 'Answers',
    inviteLabel: 'Invites',
    promoterLabel: 'Promoters',
    neutralLabel: 'Neutrals',
    detractorLabel: 'Detractors',
    noteDetractorCesLabel: 'Grades 1 e 2',
    noteNeutralCesLabel: 'Grades 3',
    notePromoterCesLabel: 'Grades 4 e 5',
    monthlyLabel: 'Monthly',
    dailyLabel: 'Daily',
    weeklyLabel: 'Weekly',
    quarterlyLabel: 'Quarterly',
    accLabel: 'Accumulated',
    accMonthlyLabel: 'Accumulated Monthly',
    accDailyLabel: 'Accumulated Daily',
    accWeeklyLabel: 'Accumulated Weekly',
    accQuarterlyLabel: 'Accumulated Quarterly',
    downloadLabel: 'Download',
    sucessLabel: 'Success',
    errorLabel: 'Oops',
    cancelLabel: 'Cancel',
    dontHaveData: "You don't have any data to display here yet.",
    downloadMsg:
      'File is being prepared! You can track the processing status in the "Downloads" menu.',
    npsLabel: 'NPS',
    csatLabel: 'CSAT',
    csatAverageLabel: 'CSAT (Average)',
    loadingLabel: 'Loading',
    noteCloudPromoter: 'Notes 4 and 5',
    noteCloudNeutral: 'Note 3',
    noteCloudDetractor: 'Notes 1 and 2',
    exportXlsLabel: 'Export table to XLS',
    bounceEmail: 'Possible email errors',
    invalidAccount: 'Invalid account',
    invalidDomain: 'Invalid domain',
    mailBoxFull: 'Mailbox full',
    antiSpamBlocking: 'Anti-Spam Blocking',
    accountUnavailable: 'Account unavailable',
    unavailableServer: 'Server unavailable',
    deliveryFailure: 'Delivery failed',
    // when translating, please keep "key" contents, translate only "value" contents
    fullMonthNames: [
      {
        key: 'janeiro',
        value: 'January',
      },
      {
        key: 'fevereiro',
        value: 'February',
      },
      {
        key: 'março',
        value: 'March',
      },
      {
        key: 'abril',
        value: 'April',
      },
      {
        key: 'maio',
        value: 'May',
      },
      {
        key: 'junho',
        value: 'June',
      },
      {
        key: 'julho',
        value: 'July',
      },
      {
        key: 'agosto',
        value: 'August',
      },
      {
        key: 'setembro',
        value: 'September',
      },
      {
        key: 'outubro',
        value: 'October',
      },
      {
        key: 'novembro',
        value: 'November',
      },
      {
        key: 'dezembro',
        value: 'December',
      },
    ],
    reportImpactReminder: 'Impact of reminders on conversion',
    cardPercentageWithReminder: '% RESPONSES WITH REMINDERS',
    cardPercentageOfNoReminder: '% RESPONSES WITHOUT REMINDERS',
    quantityInvites: 'Quantity of invitations',
    answeredInvites: 'Answered invitations',
    unansweredInvitations: 'Unanswered invitations',
    conversionPercentage: 'Conversion percentage',
    reminderName: 'Reminder',
    // when translating, please keep "key" contents, translate only "value" contents
    reportTitles: [
      {
        key: 'Evolução de NPS',
        value: 'NPS Evolution',
        cesValue: 'CES Evolution',
        csatValue: 'CSAT Evolution',
        fiveStarsValue: '5Stars Evolution',
      },
      {
        key: 'Evolução de Respostas',
        value: 'Response Evolution',
      },
      {
        key: 'Evolução de Percentuais',
        value: 'Percentage Evolution',
      },
      {
        key: 'Rankings',
        value: 'Rankings',
      },
      {
        key: 'Comparativo de Ações',
        value: 'Comparison of Actions',
      },
      {
        key: 'Comparativo de Categorias',
        value: 'Category comparison',
      },
      {
        key: 'Categorias',
        value: 'Categories',
      },
      {
        key: 'Nuvem de Palavras',
        value: 'Word Cloud',
      },
      {
        key: 'NPS por Indicadores',
        value: 'NPS by Indicator',
        cesValue: 'CES by Indicator',
        csatValue: 'CSAT by Indicator',
        fiveStarsValue: '5Stars by Indicator',
      },
      {
        key: 'Relatório de Mapa - NPS',
        value: 'Map Report - NPS',
        cesValue: 'Map Report - CES',
        csatValue: 'Map Report - CSAT',
        fiveStarsValue: 'Map Report - 5Stars',
      },
      {
        key: 'Evolução de Perguntas Adicionais',
        value: 'Evolution of Additional Questions',
      },
      {
        key: 'Comparativo Indicadores',
        value: 'Comparative Indicators',
      },
      {
        key: 'Detratores Recorrentes',
        value: 'Recurring Detractors',
      },
      {
        key: 'Quadro Resumo',
        value: 'Summary Table',
      },
      {
        key: 'Comparativo Regional e Nacional',
        value: 'Regional and National Comparison',
      },
      {
        key: 'Status dos Disparos',
        value: 'Dispatch Status',
      },
      {
        key: 'Status de Tratativas',
        value: 'Treatment Status',
      },
      {
        key: 'CXI – Pós Vendas',
        value: 'CXI - After Sales',
      },
      {
        key: 'Relatório CXI - Vendas',
        value: 'CXI Sales Report',
      },
      {
        key: 'Relatório CXI',
        value: 'CXI – Post Sales',
      },
      {
        key: 'Relatório CXI Vendas - Caminhoes',
        value: 'CXI Sales Report - Trucks',
      },
      {
        key: 'Relatório CXI Vendas - Vans',
        value: 'CXI Sales Report - Vans',
      },
      {
        key: 'Análise de sentimento',
        value: 'Sentment analysis',
      },
      {
        key: 'Analise por dispositivo',
        value: 'Device Analysis',
      },
      {
        key: 'Relatório Auditoria',
        value: 'Audit Report',
      },
      {
        key: 'Relatório Comparativo de N1 e N2',
        value: 'Comparative Report of N1 and N2',
      },
      {
        key: 'Relatório Impacto dos Lembretes',
        value: 'Reminders Impact Report',
      },
      {
        key: 'Status de Tratativas',
        value: 'Negotiation Status',
      },
      {
        key: 'Comparativo de Categorias',
        value: 'Category Comparison',
      },
      {
        key: 'Evolução de Categorias',
        value: 'Category Evolution',
      },
      {
        key: 'Evolução de Convites',
        value: 'Evolution of Invitations',
      },
      {
        key: 'Tags de Tratativas',
        value: 'Treatment Tags',
      },
    ],
    basicColumn: {
      reportTitle: 'NPS Evolution',
      csatReportTitle: 'CSAT Evolution',
      csatValueAverage: 'CSAT(average) Evolution',
      fiveStarsValue: '5Stars Evolution',
    },
    answerEvolution: {
      reportTitle: 'Response Evolution',
    },
    invitesEvolution: {
      reportTitle: 'Invites Evolution',
    },
    percentageEvolution: {
      reportTitle: 'Percentage Evolution',
    },
    tags: {
      reportTitle: 'Tags Report',
      allTags: 'All Tags',
      subtags: 'Subtags',
      totalClassified: 'Total classified treatments',
    },
    categories: {
      reportTitle: 'Category Report',
      allCategories: 'All Categories',
      scorelabel: 'Score',
      totalLabel: 'Total',
      totalCategorized: 'Total of Categorized Responses',
      promoterCategorized: 'Total of Categoried Promoter Responses',
      neutralCategorized: 'Total of Categorized Neutral Responses',
      detractorCategorized: 'Total of Categorized Detractor Responses',
      notes4and5: 'Note 4 and 5',
      note3: 'Note 3',
      notes1and3: 'Note 1 and 3',
      subcategories: 'Subcategories',
      optionText:
        'Category (Based in frequency) - Calculation: Category/Total categories.\n' +
        'Category (Based in answers) - Calculation: Category/Total answers.',
      frequencyOption: 'Category (Based in frequency)',
      normalOption: 'Category (Based in answers)',
      totalCategories: 'Total of Categories',
    },
    conversionDetails: {
      reportTitle: 'Conversion / Detailing Import Report',
      searchAction: 'Search action',
    },
    categoriesEvolution: {
      reportTitle: 'Categories Evolution Report',
      optionText:
        'Category (Based in frequency) - Calculation: Category/Total categories.\n' +
        'Category (Based in answers) - Calculation: Category/Total answers.',
      frequencyOption: 'Category (Based in frequency)',
      normalOption: 'Category (Based in answers)',
      profileLabel: 'Profile',
      selProfileLabel: 'Select Profile',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
      categoryLabel: 'Category',
      selCategoryLabel: 'Select a category',
    },
    categoriesTags: {
      categories: 'Input: Categories',
      subCategories: 'Input: Sub Categories',
      tags: 'Output: Treatment Tags',
      loadAllCategories: 'Load all Categories',
      profileLabel: 'Profile',
      selProfileLabel: 'Select Profile',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
    },
    indicators: {
      reportTitle: 'Indicator Report',
      indicatorLabel: 'Indicator',
      byIndicators: 'by indicators',
      descriptionLabel: 'Description',
      selIndicatorLabel: 'Please select an indicator to display the data.',
      noDatalabel: 'No data to display',
      noAnswerLabel: 'No answer associated with this indicator was found.',
      selIndicatorSelectLabel: 'Select an indicator',
      answerDownloadlabel: 'Answers Download',
    },
    multipleSubOptions: {
      multipleSubOptions: 'Multiple with sub options',
      optionFrequency: 'Option (Base frequency)',
      optionAnswer: 'Option (Base answer)',
    },
    comparativeIndicators: {
      reportTitle: 'Comparison of Indicators',
      valueLabel: 'Value',
      fillFieldsMsg: 'Please fill in the fields above to display the report.',
      selIndicatorLabel: 'Select an indicator',
      selValueLabel: 'Select a value',
    },
    comparativeN1N2: {
      title: 'Comparison of N1 and N2 - Percentage Analyze',
      yAxisLabel: ' N1 N2',
    },
    comparativeCategories: {
      categoryLabel: 'Category',
      reportTitle: 'Comparison of Categories - Percentage Analyze',
      reportTitleMultiple: 'Comparison of Options - Percentage Analyze',
      fillFieldsMsg: 'Please fill in the fields above to display the report.',
      selCategoryLabel: 'Select a category',
      profileLabel: 'Profile',
      selProfileLabel: 'Select Profile',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
      subcategoryLabel: 'Subcategory',
      selSubcategoryLabel: 'Select subcategory',
      analyzeLabel: 'Analyze',
      allLabel: 'All',
      yAxisLabel: 'Categorized',
    },
    detractor: {
      reportTitle: 'Recurring Detractors',
      loadingLabel: 'Loading',
      noDataLabel: 'No data to display',
      noDataMsg: 'No data found for selected filters.',
      answerDetailsLabel: 'Response Details',
      seriesNameLabel: 'Quantity of recurring detractors',
      tableCustomerLabel: 'Customer',
      tableDateLabel: 'Date',
      tableReviewLabel: 'Score',
      tablePreviousDateLabel: 'Date of previous score',
      tablePreviousReviewLabel: 'Score',
      tableDetailsLabel: 'Details',
    },
    evolAddQuestion: {
      reportTitle: 'Additional questions report',
      additionalQuestionlabel: 'Additional question',
      loadingLabel: 'Loading',
      selSelectAddQuestionLabel: 'Select an Additional question',
      selAddQuestionLabel:
        'Please select an Additional Question to display data.',
      graphTitle: 'Evolution of Additional Question',
      title: 'Evolution of Additional Questions',
    },
    groupNps: {
      reportTitle: 'Regional and National Comparison Report',
      selIh1Label: 'Please select a dealership from the filter options.',
      generalTitleLabel: 'National',
    },
    horizontalBar: {
      chartTitle: 'NPS - Percentage',
      cesChartTitle: 'CES - Percentage',
      csatChartTitle: 'CSAT - Percentage',
      chartSeries: 'Percentage',
      ceschartSeries: 'Amount',
      chartNoData: 'NPS - Percentage (no data to display)',
      cesChartNoData: 'CES - Percentage (no data to display)',
      csatChartNoData: 'CSAT - Percentage (no data to display)',
      csatchartSeries: 'Amount',
      fiveStarsTitle: '5-Stars Percentage',
      fiveStarsNoData: '5 Stars - Percentage (no data to display)',
      fiveStarschartSeries: 'Amount',
      likeDislikeTitle: 'Like/Dislike Percentage',
      likeDislikeNoData:
        'Like/Dislike - Percentual Percentage (no data to display)',
      likeDislikechartSeries: 'Amount',
      csatPromoters: '9 and 10',
      csatPassives: '7 and 8',
    },
    inviteStatus: {
      reportTitle: 'Dispatch Status',
      noDataLabel: 'No data to display',
      noDataMsg: 'No data found for selected filters.',
      seeDetailsLabel: 'See details',
      emailLabel: 'Email',
      smsLabel: 'SMS',
      invitesLabel: 'Dispatches',
      deliveredLabel: 'Deliveries',
      openedLabel: 'Opened',
      clickedLabel: 'Clicks',
      bounceLabel: 'Bounces',
      spamLabel: 'Spam Reports',
      notDeliveredLabel: 'Not Delivered',
      phoneLabel: 'Telephone',
      detailDeliveredLabel: 'Details of sent invitations',
      detailOpenedLabel: 'Details of invitations that were opened',
      detailClickedLabel: 'Details of invitations that were clicked',
      detailSpamLabel: 'Details of invitations marked as spam',
      detailBounceLabel: 'Details of bounced invitations',
      detailNotReceivedLabel: 'Details of unreceived invitations',
      detailDefaultLabel: 'Invitation Details',
      deliveryPercentLabel: 'Delivery Percentage',
      customerLabel: 'Customer',
      inviteIdLabel: 'Invitation ID',
      sentDateLabel: 'Sent Date',
      invitesLabelInfoEmail:
        'Number of requests to the customer’s email via the IndeCX API.',
      deliveredLabelInfo: `The accepted response generated by the recipients' mail server.`,
      openedLabelInfo: 'Number of emails opened by the recipient.',
      clickedLabelInfo:
        'Number of times the recipient clicked on the link to answer the survey within the email.',
      bounceLabelInfo:
        'Number of times the server cannot receive or accept the message.',
      spamLabelInfo:
        'Whenever a recipient marks your email as spam and their mail server tells us about it.',
      invitesLabelInfoSMS:
        'Number of requests to the customer’s number via the IndeCX API.',
      deliveredLabelInfoSMS: `The accepted response generated by the recipients' SMS server.`,
      notDeliveredLabelInfo:
        'Number of times the server cannot receive or accept the message.',
    },
    mapChart: {
      brasil: 'Brazil',
      mapMundi: 'World map',
      reportTitle: 'Map Report - {metric}',
      subtitleLabel: 'Subtitle',
      npslt0: 'NPS less than 0',
      npslt50: 'NPS of 0 to 49',
      npslt70: 'NPS of 50 to 69',
      npslt80: 'NPS of 70 to 79',
      npsge80: 'NPS of 80 to 100',
      ufLabel: 'UF',
      localeLabel: 'Country',
    },
    treatmentMonitoring: {
      treatment: 'Treatises',
      averageTreatment: 'Average of treatments performed',
      averageTreatmentDesc:
        'Average of deals with Status Answered in the selected period',
      totalPeriod: 'otal in period',
      startAverage: 'Average time to start treatment',
      startAverageDesc:
        'Time between the registration of the first deal and the date of the reply.',
      hours: 'hours',
      averageAnswer: 'Average response time',
      averageAnswerDesc:
        'Average time between the end of the treatment with Status Responded and the date of response.',
      averageNoStart: 'Average time without treatment started',
      averageNoStartDesc:
        'Time between the current date and the date of the treatment response.',
      averagePending: 'Average time of pending deals',
      averagePendingDesc:
        'Time between the current date and the start date of the first negotiation in the selected period',
      operatorStatus: 'Operator Status',
      currentStatus: 'Current Status',
      treatmentCard: 'Treatative',
      averagePeriod: 'Average of negotiations in the period',
      massTreatment: 'Mass treatments in period',
      profile: 'Profile',
    },
    monthlyDetractors: {
      reportTitle: 'Monthly Detractors',
      noDataLabel: 'Monthly Detractors - No data to display',
      noDataMsg: 'No data found for selected filters.',
      chartTitle: 'Monthly Detractors',
      chartSeries: 'number of detratores',
    },
    csat: {
      csatLabelReport: 'Scale 1 to 10',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    nps: {
      npsLabelReport: 'NPS',
      addQuestionLabel: 'Additional question',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    ces: {
      cesLabelReport: 'Scale Ces 1 to 5',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    emotion: {
      emotionLabel: 'Emotion',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    likeDislike: {
      likeDislikeLabel: 'Like Dislike',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    likeDislikeGroup: {
      likeDislikeLabel: 'Like Dislike',
      addQuestionLabel: 'Additional question',
      branchLabel: 'Branch',
      groupLabel: 'Regional',
      companyLabel: 'National',
    },
    likert: {
      likertLabel: 'LIKERT',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    reviews: {
      reviewsLabel: 'REVIEWS',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    reviewsGroup: {
      reviewsLabel: 'REVIEWS',
      addQuestionLabel: 'Additional question',
      branchLabel: 'Branch',
      groupLabel: 'Regional',
      companyLabel: 'National',
    },
    summaryBoard: {
      reportTitle: 'Summary Table - Management',
      invitesLabel: 'Invitations',
      answersLabel: 'Answers',
      conversionLabel: 'Conversion',
      receivedEmails: 'Received Emails',
      receivedPhones: 'Received Cell phones',
      channelQtLabel: 'Collected Channel Quantity',
      emailLabel: 'Email',
      smsLabel: 'SMS',
      manualLabel: 'Manual',
      othersLabel: 'Others',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
      top5detractors: 'Top 5 Categories',
      top5promoters: 'Top 5 Categories',
      categorizedLabel: '% of occurrences have been categorized',
      positionMsg1: 'Your position is',
      positionMsg2: 'National ranking in the selected period',
    },
    npsBar: {
      reportTitle: 'NPS - Net Promoter Score',
      csatReportTitle: 'CSAT - Customer Satisfaction Score',
      csatAverageReportTitle: 'CSAT(Average) - Customer Satisfaction Score',
      csat0to10ReportTitle: 'CSAT(0 to 10) - Customer Satisfaction Score',
      csat0to10AverageReportTitle:
        'CSAT(0 to 10) - Customer Satisfaction Score',
      fiveStarsReportTitle: '5-Stars',
      npsMessage: 'Your NPS is',
      csatMessage: 'Your CSAT is',
      fiveStarsMessage: 'Your 5 stars is',
      noDataMsg: 'No data to display',
      noData: 'No data in the period',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
    },
    treatmentStatus: {
      noDataLabel: 'No data to display',
      noDataMsg: 'No data was found for the selected filters.',
      allSelected: 'All Profiles',
      promoterLabel: 'Promoter',
      neutralLabel: 'Neutral',
      detractorLabel: 'Detractor',
      answeredLabel: 'Answered',
      openedLabel: 'Opened',
      analysedLabel: 'Analyzing',
      others: 'Others',
      staggeredLabel: 'Dispatched',
      chartTitle: 'Status of monthly treatments',
    },
    verticalColumn: {
      chartTitle: 'NPS - Scores',
      chartSeries: 'Quantity',
      csatChartTitle: 'CSAT - Notas',
      likeDislikeReportTitle: 'Like/Dislike - Grades',
    },
    wordCloud: {
      anonimousLabel: 'Anonymous',
      noDataMessage: 'No word selected.',
      commentLabel: 'Comment',
      dateLabel: 'Date',
      gradeLabel: 'Score',
      customerLabel: 'Customer',
      detailsLabel: 'Details',
    },
    cxiReport: {
      reportTitle: 'After-Sales CXI Indicator',
      cxiLabel: 'CXI',
      noDataMsg: 'No data to display',
      reportHeader1: 'After-sales CXI Report',
      reportHeader2:
        'The CXI indicator is composed of 3 indicators: Overall Satisfaction (50%), Recommendation (25%) and Revisit (25%).',
      questionHeader: 'Question',
      score: 'Score',
      index: 'Consolidated index',
      satisfaction: 'Satisfaction',
      indexByMonth: 'Index by month',
    },
    cxiReport2024: {
      reportTitle: 'CXI After-sales Indicator',
      cxiLabel: 'Indicator per month',
      noDataMsg: 'No data to display',
      reportHeader1: 'CXI After-sales Report',
      reportHeader2:
        ' The Final Indicator is composed as follows: (Average of Item A * 30%) + (Average of Item B * 70%)',
      reportHeader3:
        'The grade is based on the sum of all surveys answered according to the filtered period.',
      questionHeader: 'Question',
      score: 'Score',
      graphicTitle: 'Final Indicator - 360',
      indexByMonth: 'Index by month',
      questionA: 'Questions - Items A (Additional questions)',
      questionB: 'Questions - Items B (CXI)',
    },
    cxiSalesReport: {
      reportTitle: 'CXI Indicator',
      cxiLabel: 'CXI',
      noDataMsg: 'No data to display',
      reportHeader1: 'Sales CXI Report',
      reportHeader2:
        'The CXI indicator is composed of 3 indicators: Overall Satisfaction (50%), Recommendation (25%) and Revisit (25%)',
      questionHeader: 'Question',
      score: 'Score',
    },
    ccsi: {
      reportTitle: 'CCSI Indicator',
      ccsiLabel: 'CCSI',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    hgsi: {
      reportTitle: 'HGSI Indicator',
      hgsiLabel: 'HGSI',
      scsiLabel: 'SCSI',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    prehgsi: {
      reportTitle: 'PRE-HGSI Indicator',
      prehgsiLabel: 'PRE-HGSI',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    fcsi: {
      reportTitle: 'FCSI Indicator',
      fcsiLabel: 'FCSI',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
    },
    multiples: {
      multiplesLabel: 'Multiple Choice',
      addQuestionLabel: 'Additional question',
      scoreLabel: 'Score',
      totalLabel: 'Total',
      totalAnswersLabel: 'Total Answers',
    },
    partsAvailability: {
      filterTitle: 'Filter by subsegment',
      filterPlaceholder: 'Select a sub-segment',
      reportTitle: 'Parts availability',
      table: {
        date: 'Date',
        review: 'Note',
        customer: 'Customer',
        comment: 'Comment',
        details: 'Details',
      },
    },
    sentmentAnalysis: {
      reportTitle: 'Sentment analysis',
      reportDescription:
        'IndeCX uses Artificial Intelligence to classify sentiment and extract keywords based on comments. The score below indicates the level of feeling, which can vary from -100 to 100. ',
      total: 'Total',
      percentAnalyzed: 'of the responses were analyzed.',
      positive: 'Positive',
      neutral: 'Neutral',
      negative: 'Negative',
      classificationReportTitle: 'Sentiment classification',
      classificationReportTitleMonthly: 'Classification of feeling over time',
      sentmentScoreReportTitle: 'Sentiment Score',
      sentmentScoreReportTitleMonthly: 'Sentiment Score by Month',
      keywordsTablePositive: {
        keywords: 'Positive Keywords',
        percentage: '%',
        total: 'Total',
      },
      keywordsTableNeutral: {
        keywords: 'Neutral Keywords',
        percentage: '%',
        total: 'Total',
      },
      keywordsTableNegative: {
        keywords: 'Negative Keywords',
        percentage: '%',
        total: 'Total',
      },
      indicatorTitle: 'Sentiment by indicator',
      selectTitle: 'Indicator:',
      selectPlaceholder: 'Select an indicator',
      indicatorTable: {
        indicator: 'Indicator',
        description: 'Description',
        score: 'Score',
        total: 'Total',
      },
    },
    deviceAnalysis: {
      deviceTitle: 'Responses by device',
      deviceSubText: 'Device used for survey response',
      qty: 'Quantity',
      browserTitle: 'Response by browser',
      browserSubText: 'Browser used for search response',
      soTitle: 'Response by operating system',
      soSubText: 'Operating system used on devices',
      selectDevice: 'Select the device',
      all: 'All',
    },
  },
  aiReports: {
    aiAnalysis: 'AI Analyse',
    swotAnalysis: 'SWOT Analyse ',
    swotAnalysisText:
      'Análise SWOT é uma técnica de planejamento estratégico utilizada para auxiliar pessoas ou organizações a identificar forças, fraquezas, oportunidades, e ameaças relacionadas à competição em negócios ou planejamento de projetos.',
    summarization: 'Sumarização',
    summarizationText:
      'Sumarização é uma técnica de planejamento estratégico utilizada para auxiliar pessoas ou organizações a identificar forças, fraquezas, oportunidades, e ameaças relacionadas à competição em negócios ou planejamento de projetos.',
    selectReport: 'Select Report',
    comingSoon: 'Soon',
    newAnalysis: 'New Analysis',
    searchInput: 'Search',
    searchButton: 'Clear',
    swotTable: {
      labels: {
        id: 'ID',
        filters: 'Filters for SWOT Analysis',
        createdAt: 'Created at',
        period: 'Period',
        qtd: 'Sample',
        status: 'Status',
        visualization: 'Preview',
      },
      status: {
        processando: 'Processing',
        processado: 'Processed',
        falha: 'Fail',
      },
    },
    summarizationTable: {
      labels: {
        id: 'ID',
        filters: 'Filters for Summarization',
        createdAt: 'Created at',
        period: 'Period',
        qtd: 'Sample',
        status: 'Status',
        visualization: 'Preview',
      },
      status: {
        processando: 'Processing',
        processado: 'Processed',
        falha: 'Fail',
      },
    },
    newAiReport: {
      analysisFilter: 'Analysis filter',
      analysisRevision: 'Analysis revision',
      answersPeriod: 'Answers period',
      filters: 'Filters',
      actionGroup: 'Action group',
      action: 'Action',
      profile: 'Profile',
      ih1: 'Branch',
      selectedItens: 'Applied filters',
      actions: 'Actions',
      revision: 'Data revision',
      selectedFilters: 'Selected filters',
      cancelButton: 'Cancel',
      nextButton: 'Next',
      analyseButton: 'Analyse',
      goBackButton: 'Go back',
    },
  },
  genericMessages: {
    save: 'Save',
    cancel: 'Cancel',
    success: {
      title: 'Success!',
      description: 'Your changes have been successfully saved!',
    },
    error: {
      title: 'Error',
      description: 'There was an unexpected error. Try again later!',
    },
    goBack: 'Go back',
    noDataTitle: 'No data to be displayed',
    noDataDescription: 'No data was found for the selected filters.',
  },

  informationAboutNpsDash: {
    aboutNps: 'Information about NPS',
    rangeNps: 'NPS RANGE',
    reference: '*Reference INDECX',
    awfulTitle: 'Less than 0 - Terrible NPS:',
    awful:
      'Companies with an NPS value in this zone have most of their detractor customers.​',
    badTitle: 'From 0 to 49 - Bad NPS:',
    bad: 'Companies in this zone usually have high numbers of promoters and detractors, but the number of neutrals also influences.​',
    goodTitle: 'From 50 to 69 – Good NPS:',
    good: 'Companies that care about providing excellent service. Number of promoters outnumber detractors.​',
    veryGoodTitle: 'From 70 to 79 – Very Good NPS:',
    veryGood:
      'Companies that offer a reference service in customer satisfaction. Very few detractors.​',
    excellentTitle: 'From 80 to 100 - Excellent NPS:',
    excellent:
      ' Few companies are in this area and have become a reference in the customer service they offer.​',
  },

  panel: {
    panelDataTime: {
      day: 'Diary',
      week: 'Weekly',
      month: 'Monthly',
      quarter: 'Quarterly',
    },
    titleSideBar: 'Panels',
    createCard: {
      choosePanel: 'Choose the type of panel',
      configPanel: 'Panel configuration',
      useTemplate: 'Use template',
      template:
        'Our team of professionals debuted a unique template thinking about your client.',
      soon: 'coming soon!',
      createPanel: 'Create panel',
      create:
        'Create your customizable panel and get a complete view of your customer experience.',
      createPanelButton: 'Create Panel',
      title: 'Choose an option below',
    },
    createCardSecondStep: {
      panelTitle: 'Panel Title',
      description: 'Description',
      accessPermission: 'Profiles that will have access',
      createPanel: 'Create custom panel',
      cancel: 'Cancel',
      save: 'Save',
    },
    createCardPanel: {
      modalTitle: 'Create Card',
      modal:
        'Create your custom card for your panelenter the name and choose the metrics that best suit your needs.',
      cardTitle: 'Card title',
      metric: 'Choose the metric: select the metric',
      metricDescription: 'select the metric ',
      type: 'Choose the type of analysis',
      reportName: 'Choose the report to display',
      timeChoise: 'Choose the time',
      typeData: {
        sentimentAnalyze: 'Sentiment analysis',
        sentimentAnalyzeReports: {
          sentimentClassification: 'Sentiment rating',
          sentimentEvolution: 'Evolution of Sentiment ',
          sentimentScore: 'Sentiment score',
          topFiveKey: 'Top 5 Keywords',
        },
        npsAnalytics: 'NPS analysis',
        cesAnalytics: 'CES analysis',
        csatAnalytics: 'CSAT analysis',
        fiveStarsAnalytics: '5-Stars analysis',
        likeDislike: ' Like and Dislike analysis',
        npsAnalyticsReports: {
          invitationsAnalysis: 'Invitations Analysis',
          comparativeIndicators: 'Comparative Indicators',
          gradeDistribution: 'Grade distribution',
          invitesEvolution: 'Evolution of invitations',
          npsEvolution: 'Evolution of nps',
          percentEvolution: 'Evolution of percentages',
          indexNps: 'Index NPS',
          npsPercentage: 'NPS Percentage',
          mapReport: 'Map report',
          recurringDetractors: 'Recurring detractors',
        },
        categories: 'Categories',
        categoriesReports: {
          categories: 'Categories',
        },
        additionalQuestion: 'Additional Questions',
        additionalQuestionReports: {
          multipleChoice: 'Ranking Multiple choice',
          ces1a5: 'Ranking CES 1 to 5',
          emotion: 'Ranking Emotion',
          scale0a10: 'Ranking Scale 0 to 10',
          likeOrDeslike: 'Ranking Like/dislike',
          likert: 'Ranking Likert',
          nps: 'Ranking NPS',
          review: 'Ranking Review',
        },
        others: 'Others',
        othersReports: {
          deviceAnalysis: 'Device Analysis',
          conversion: 'Conversion',
          evolutionOfAnswers: 'Evolution of answers',
          keyCloud: 'Cloud of keyphrases',
          replyByChannel: 'Reply by channels',
          treatmentStatus: 'Treatment Status',
        },
      },
      chooseTime: {
        today: 'Today',
        yesterday: 'Yesterday',
        last30Days: 'Last 30 days',
        currentMonth: 'Current month',
        lastMonth: 'Last month',
        currentYear: 'Current year',
        lastYear: 'Last year',
        everyPeriod: 'Every period',
        customized: 'Customized',
        choose: 'Choose the period',
      },
      editCard: {
        title: 'Edit card',
        description:
          'Edit your custom card for your dashboard, enter the name and choose the metrics that best suit your needs.',
        titlePanel: 'Panel title',
        chooseMetric: 'Choose the metric',
        chooseTypeAnalysis: 'Choose the type of analysis',
        chooseReport: 'Choose the report to display',
        choosePeriod: 'Choose period',
        chooseFilter: 'Choose filter',
        chooseAction: 'Choose action',
        chooseBranch: 'Choose the branch',
        chooseIndicator: 'Choose the indicator',
        showMore: 'Load more',
        chooseValueIndicator: 'Choose the indicator value',
        chooseTypeGraph: 'Choose the type of graph to be used',
        graphics: 'Gráficos',
        save: 'Save',
        cancel: 'Cancel',
      },
      chooseFilterTitle: 'Choose the filter',
      chooseFilter: {
        actionGroup: 'Acctions group',
        action: 'Acction',
        indicator: 'Indicator',
        filial: 'Branch',
      },
      metrics: {
        selectMetric: 'Select the metric',
        nps0to10: 'NPS - scale 0 to 10',
        nps1to5: 'NPS - scale 1 to 5',
        ces1to5: 'CES - scale 1 to 5',
        csat1To5: 'CSAT - scale 1 to 5(Top 2 box)',
        csat1To5Media: 'CSAT - scale 1 to 5(media)',
        fiveStars: '5-Stars',
        likeDislike: 'Like/Dislike 0 and 1',
      },
      panelHeader: {
        srcPanel: 'Search panel',
        edit: 'Edit',
        reload: 'Reload',
        custom: 'Customization',
        addGraphcs: 'Add graph',
        loadMore: 'Load more>>',
      },
      homePageCard: {
        metric: 'Metric',
        actionGroup: 'Action group',
        branch: 'Branch',
        area: 'Area',
        data: 'Data',
        action: 'Action',
        title: 'Fill in a title',
        chooseGraphicsType: 'Choose the type of chart to use',
      },
      formTextArea: {
        chooseAnalysis: 'Select an analysis',
        choosePeriod: 'Choose a period',
        chooseFilterDescription: 'Choose the filter',
        chooseMetric: 'Select the metric',
        title: 'Fill in a title',
      },
      filterOptions: {
        actionGroupName: 'Choose a group',
        action: 'Select an action',
        indicator: 'select an indicator',
        filial: 'select an indicator',
        chooseActionTitle: 'Choose the action',
        chooseFilialTitle: 'Choose the branch',
        chooseInicatorTitle: 'Choose the indicator',
        chooseIndicatorValue: 'Choose the indicator value',
        chooseValue: 'Choose an value',
      },
    },
    pageHome: {
      titlePage: 'My Panel - Beta',
      findPanel: 'Search Panel',
      noHavePanel: `You don't have any personalized panel!`,
      morePanel: '+ Add panel',
      wouldDelete: 'Are you sure you want to delete this panel?',
      wouldDeleteCard: 'Are you sure you want to delete this card?',
      description:
        'All configured changes will be lost and you will not be able to recover them.',
      yes: 'Yes',
      no: 'No',
      date: 'Date',
    },
    generalButtons: {
      edit: 'Edit',
      delete: 'Delete',
      addGraphics: 'Add',
      save: 'Save',
      reload: 'Reload',
      custom: 'Customization',
      addGraphcs: 'Add graphic',
      findPanel: 'Search panel',
    },
  },
  actionTranslateUpdate: {
    multiLanguage: 'Multi Language',
    pauseAction: 'Pause Action',
    yes: 'Yes',
    no: 'No',
    staticQuest:
      'Em uma escala de 1 a 5, quanto você indicatia a IndeCX para um amigo ou familiar?',
    requireAddQuest: 'Required per additional question',
    textBeforeEmoji:
      'When enabling this option, it will display in the settings',
    textAfterEmoji:
      'of each question the possibility of making that additional question obligatory',
    options: {
      title: 'Options.',
      clone: 'Clone action',
      groupCategory: 'Category group',
      groupTagsTreatment: 'Treatments tag groups',
      groupTags: 'Group tag',
      removeAction: 'Remove action',
      webHookRegister: 'Regiter webhook',
      emailRegister: 'Register Email (Sender)',
      hideDefault: 'Hide by default',
    },
    logicRules: {
      modalTitle: 'Logic rules',
      description: `Create rules to disable questions according to your customers' response.`,
      conditionals: 'If the anwser to the question below',
      is: 'Is',
      equal: 'Equal to',
      larger: 'Bigger then',
      largerOrEqual: 'Bigger or equal to',
      smaller: 'Less than',
      smallerOrEqual: 'Less than or equal to',
      different: 'Different than',
      turnOff: 'Then disable the questions below:',
      selectAnswer: 'Select an anwser',
    },
    moreOptionsRules: {
      modalTitle: 'More options',
      describe:
        'Enable some of the options below to add additional customizations to your survey',
      addNewField: 'Add a comment field',
      notApply: ' Add option “Does not apply”',
      notApplyDescribe: `Display the question based on a condition of the main metric`,
      labelText: `Display the question only if the respondent's profile equals:`,
      seeAnswer:
        'Display the question only if the indicator selected below is equal to or different from the parameter value:',
      indicator: 'Indicator:',
      indicatorDescribe: 'As opções mudam de acordo com a empresa',
      critrion: 'Criterion',
      equal: 'Equal to',
      different: 'Different than',
      contains: 'Contains',
      params: 'Parameter',
    },

    templateTranslateRef: {
      templateTitle: 'Template of buttons',
      buttonScale: 'Note reference',
      button: 'Button',
      automaticAnswer: 'Automatic answer',
      showIndecxLogo: 'Show IndeCX logo',
      noteRef: 'Note reference',
      customSubmitButton: 'Customize submit button',
      default: 'Default',
      colors: '3 Colors',
    },
    quarentine: {
      dispatch: 'Dispatch',
      period: 'Period in days',
      validity: 'Validity:',
      options: {
        allData: 'General',
        thisAction: 'For this action',
        actionGroup: ' For the action group',
      },
      answer: 'Answer',
    },
  },

  acumulated: 'Accumulated',

  configUpdateNow: {
    consumption: {
      email: 'Contracted volume email',
      sms: 'Volume contracted SMS',
      semail: 'Current Balance e-mail',
      ssms: 'SMS Current balance',
    },
    template: {
      subject: 'Return Customer Experience Team',
      sender: 'Enter the sender’s name',
      selectTemplate: 'Select a template',
      pressTemplateName: 'Enter the name of the template',
      sucess: 'Success',
      descriptionSucess: 'Treatment group successfully created',
      descriptionRemove: 'Treatment group successufully removed',
      descriptionUpdate: 'Treatment group successufully updated',
      alertAttetion: 'Waring',
      alertDescription: 'Fill in all fields!',
      alertUpdate: 'Updated template',
      alertUpdateDescription: 'Your template has been changed successfully!',
    },
    tratativeRules: {
      modalTitle: 'Add treatment rule',
      modalTitleEdit: 'Edit treatment rule',
      ruleTitle: 'Rule title',
      ruleTime: 'Period rules',
      classification: 'Sort by',
      newlast: 'Newest',
      oldest: 'Older',
      ruleStack: 'Operator queue rules',
      orderWork: 'Work order ',
      schedule: 'Scheduling',
      detractor: 'Detractors',
      neutrals: 'Neutrals',
      promoters: 'Promoters',
      chooseAnActions: 'Choose actions',
      actions: 'Action',
      selectAction: 'Select actions',
      newRoleButton: 'New operation rule',
      isOn: 'Active',
      ruleName: 'Rule name',
      editeRule: 'Edit',
      channel: 'Channel',
      save: 'Save',
      saveChange: 'Save Change',
    },
    reportOption: {
      title: 'Reporting options',
      describe: 'Enable your account-specific reports for this profile',
      searchMon: 'Reporting Options',
      conversionReport: 'Reporting Options',
      category: 'Conversion Report / Import Details',
      hts: 'Category x Treatment Tag',
      specificReport: 'Specific reports',
      habilit: 'Enable',
      searchFor: 'Search for',
    },
  },

  clientsUpdate: {
    modalTitle: 'invitation details',
    changeData: 'Change invitation details',
    field: 'Field',
    value: 'Value',
    name: 'Name',
    email: 'Email',
    tel: 'Telephone',
    city: 'City',
    uf: 'UF',
    clietType: 'Client Type',
  },

  userPermissionTranslateUpdate: {
    actionPermissionTitle: 'Actions Menu',
    actionMenu: {
      viewMenu: 'View Menu',
      details: 'Details',
      editAction: 'Edit Actions',
      sendDispatcher: 'Send (shooting)',
      deleteAction: 'Delete Action',
      createAction: 'Create Action',
    },
    menuAnswers: {
      answerMenuTitle: '',
      answerMenu: {
        viewMenu: '',
        editComment: '',
        deleteResponse: '',
        incognitoMode: '',
        categorizationMode: '',
      },
    },
    manualMenuTitle: '',
    manualMenu: {
      viewMenu: '',
      registerAnswer: '',
      icognitoMode: '',
    },
    menuDispatcherTitle: '',
    menuDispatcher: {
      viewMenu: '',
      viewRessend: '',
      viewWhatsApp: '',
      resendExecute: '',
      remindersView: '',
      cancelReminders: '',
      scheduleView: '',
      scheduleCancel: '',
      incognitoMode: '',
    },
    treatmentMenuTitle: '',
    treatmentMenu: {
      viewMenu: '',
      details: '',
      answerCategory: '',
      changeStatus: '',
      chancheClosedStatus: '',
      massTreatment: '',
      replyByEmail: '',
      categorizeNegotiations: '',
      enableComment: '',
      enableResponsible: '',
      enableAttachment: '',
    },
    reportMenuTitle: '',
    reportMenu: {
      viewMenu: '',
      powerBi: '',
      AIAnalysis: '',
    },
    menuTrashTitle: '',
    menuTrash: {
      viewMenu: '',
      restoreAnswer: '',
      restoreActions: '',
      incognitoMode: '',
    },
    menuDashboardTitle: '',
    menuDashboard: {
      viewMenu: '',
    },

    menuClientTitle: '',
    menuClient: {
      viewMenu: '',
      incognitoMode: '',
      editData: '',
    },
    menuActionGroupTitle: '',
    menuActionGroup: {
      viewMenu: '',
      actionAssociation: '',
    },
    ourFileTitle: '',
    ourFileTitle: {
      downloads: '',
      uploads: '',
    },
    panelsMenuTitle: '',
    panelsMenu: {
      viewMenu: '',
      sharePanel: '',
      createPanel: '',
      editPanel: '',
      deletePanel: '',
    },
    myConfigurationsTitle: '',
    myConfigurations: {
      viewMenu: '',
    },
  },

  acessProfileTranslateUpdate: {
    modaltitle: 'Reporting options',
    describe: 'Enable your account-specific reports for this profile',
    especificReport: {
      searchMonitoring: 'Search monitoring',
      conversionReport: 'Conversion Report / Import Detail',
      categories: 'Category x Treatment Tag',
      htsReport: 'HTS report',
    },
    especificReportTitle: 'Specific reports',
    apply: 'Enable',
  },

  tagsTreatmenTranslateUpdate: {
    title: 'Treatment tags',
    addTag: 'Include Tags',
    removeTagTitle: 'Remove tag',
    describe: 'Are you sure you want to remove this tag?',
  },
  actionUploadModal: {
    title: 'Processing',
    description:
      'Your file is being processed, please wait! This may take a few seconds.',
  },
};

export default messages;



// WEBPACK FOOTER //
// ./src/lang/us.js